<template>
  <div class="room gas-clamp">
    <RefreshBlock @refreshData="refreshData"></RefreshBlock>
    <div class="main-cable" v-loading="loading">
      <div class="cable-title">
        <h2>嘉兴侧塔柱</h2>
      </div>
      <div class="cable-main">
        <div class="legend">
          <!-- <div class="sensor1">排气口</div>
          <div class="sensor2">进气口</div> -->
        </div>
        <div class="legend-station">
          <i class="iconfont iconshebei"></i>
          <span>除湿机</span>
        </div>
        <div class="legend-right">
          <div class="running">设备运行</div>
          <div class="stopped">设备停止</div>
          <div class="default">数据中断</div>
        </div>
        <div class="dir left-dir">
          <i class="iconfont icongeo-arrow-left"></i>
          <span class="dir-text">嘉兴</span>
        </div>
        <div class="dir right-dir">
          <i class="iconfont icongeo-arrow-left-copy"></i>
          <span class="dir-text">绍兴</span>
        </div>
        <div class="cable-img">
          <div class="tower-name tower-name-z3">Z3</div>
          <div class="tower-name tower-name-z4">Z4</div>
          <div class="tower-name tower-name-z5">Z5</div>

          <el-tooltip class="station-block station-block-z3-top" content="Z3上塔T1除湿机" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/jiashao/towerStation/station2"></router-link>
          </el-tooltip>
          <div class="stati sta-z3-top">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                Z3上塔T1除湿机
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电流",
                    ["Ia", "Ib", "Ic"],
                    [currentADehumidifierZ3TowerTop, currentBDehumidifierZ3TowerTop, currentCDehumidifierZ3TowerTop],
                    ["A", "A", "A"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电压",
                    ["ab", "bc", "ac"],
                    [voltageABDehumidifierZ3TowerTop, voltageBCDehumidifierZ3TowerTop, voltageACDehumidifierZ3TowerTop],
                    ["V", "V", "V"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "功率",
                    ["P", "Q", "S"],
                    [powerActiveDehumidifierZ3TowerTop, powerReactiveDehumidifierZ3TowerTop,
                      powerApparentDehumidifierZ3TowerTop],
                    ["kW", "kvar", "kVA"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电能",
                    ["Wp", "Wq"],
                    [energyActiveDehumidifierZ3TowerTop, energyReactiveDehumidifierZ3TowerTop],
                    ["kWh", "kvarh"]
                  )
                }}
                <br />
                {{ assembleTooltip_simpleKeyValue("频率", frequencyDehumidifierZ3TowerTop, "Hz") }}
              </div>
              <div :class="errorZ3TowerTop" class="state-info bottom-pos" @dblclick="hrefToScenario('b459fe14-36fe-481b-a51a-7e7325dd9ae1')"
                v-loading="stationNameLoadingDict['stationT1']">
                <p>
                  <span class="bold">Z3上塔T1除湿机</span>
                  <span :class="runningClassZ3TowerTop" class="valve-sign"></span>
                </p>
                <p>
                  <span>电流</span>
                  <span>{{ currentADehumidifierZ3TowerTop | toFixed }}A {{ currentBDehumidifierZ3TowerTop | toFixed }}A
                    {{ currentCDehumidifierZ3TowerTop | toFixed }}A</span>
                </p>
                <p>
                  <span>电压</span>
                  <span>{{ voltageABDehumidifierZ3TowerTop | toFixed }}V {{ voltageBCDehumidifierZ3TowerTop | toFixed
                  }}V
                    {{ voltageACDehumidifierZ3TowerTop | toFixed }}V
                  </span>
                </p>
                <p>
                  <span>功率</span>
                  <span>{{ powerActiveDehumidifierZ3TowerTop | toFixed }}kW {{ powerReactiveDehumidifierZ3TowerTop |
                    toFixed }}Kvar
                    {{ powerApparentDehumidifierZ3TowerTop | toFixed }}kVA
                  </span>
                </p>
                <p>
                  <span>电能</span>
                  <span>{{ energyActiveDehumidifierZ3TowerTop | toFixed }}kWh {{ energyReactiveDehumidifierZ3TowerTop |
                    toFixed }}kvarh</span>
                </p>
                <p>
                  <span>频率</span>
                  <span>{{ frequencyDehumidifierZ3TowerTop | toFixed }}Hz</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <el-tooltip class="station-block station-block-z3-mid" content="Z3中塔T2除湿机" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/jiashao/towerStation/station1"></router-link>
          </el-tooltip>
          <div class="stati sta-z3-mid">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                Z3中塔T2除湿机
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电流",
                    ["Ia", "Ib", "Ic"],
                    [currentADehumidifierZ3TowerMid, currentBDehumidifierZ3TowerMid, currentCDehumidifierZ3TowerMid],
                    ["A", "A", "A"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电压",
                    ["ab", "bc", "ac"],
                    [voltageABDehumidifierZ3TowerMid, voltageBCDehumidifierZ3TowerMid, voltageACDehumidifierZ3TowerMid],
                    ["V", "V", "V"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "功率",
                    ["P", "Q", "S"],
                    [powerActiveDehumidifierZ3TowerMid, powerReactiveDehumidifierZ3TowerMid,
                      powerApparentDehumidifierZ3TowerMid],
                    ["kW", "kvar", "kVA"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电能",
                    ["Wp", "Wq"],
                    [energyActiveDehumidifierZ3TowerMid, energyReactiveDehumidifierZ3TowerMid],
                    ["kWh", "kvarh"]
                  )
                }}
                <br />
                {{ assembleTooltip_simpleKeyValue("频率", frequencyDehumidifierZ3TowerMid, "Hz") }}
              </div>
              <div :class="errorZ3TowerMid" class="state-info right-pos" @dblclick="hrefToScenario('24acfada-0e97-42b1-b6e7-02c064ef85a5')"
                v-loading="stationNameLoadingDict['stationT2']">
                <p>
                  <span class="bold">Z3中塔T2除湿机</span>
                  <span :class="runningClassZ3TowerMid" class="valve-sign"></span>
                </p>
                <p>
                  <span>电流</span>
                  <span>{{ currentADehumidifierZ3TowerMid | toFixed }}A {{ currentBDehumidifierZ3TowerMid | toFixed }}A
                    {{ currentCDehumidifierZ3TowerMid | toFixed }}A</span>
                </p>
                <p>
                  <span>电压</span>
                  <span>{{ voltageABDehumidifierZ3TowerMid | toFixed }}V {{ voltageBCDehumidifierZ3TowerMid | toFixed
                  }}V
                    {{ voltageACDehumidifierZ3TowerMid | toFixed }}V
                  </span>
                </p>
                <p>
                  <span>功率</span>
                  <span>{{ powerActiveDehumidifierZ3TowerMid | toFixed }}kW {{ powerReactiveDehumidifierZ3TowerMid |
                    toFixed }}Kvar
                    {{ powerApparentDehumidifierZ3TowerMid | toFixed }}kVA
                  </span>
                </p>
                <p>
                  <span>电能</span>
                  <span>{{ energyActiveDehumidifierZ3TowerMid | toFixed }}kWh {{ energyReactiveDehumidifierZ3TowerMid |
                    toFixed }}kvarh</span>
                </p>
                <p>
                  <span>频率</span>
                  <span>{{ frequencyDehumidifierZ3TowerMid | toFixed }}Hz</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <el-tooltip class="station-block station-block-z4-top" content="Z4上塔T3除湿机" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/jiashao/towerStation/station5"></router-link>
          </el-tooltip>
          <div class="stati sta-z4-top">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                Z4上塔T3除湿机
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电流",
                    ["Ia", "Ib", "Ic"],
                    [currentADehumidifierZ4TowerTop, currentBDehumidifierZ4TowerTop, currentCDehumidifierZ4TowerTop],
                    ["A", "A", "A"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电压",
                    ["ab", "bc", "ac"],
                    [voltageABDehumidifierZ4TowerTop, voltageBCDehumidifierZ4TowerTop, voltageACDehumidifierZ4TowerTop],
                    ["V", "V", "V"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "功率",
                    ["P", "Q", "S"],
                    [powerActiveDehumidifierZ4TowerTop, powerReactiveDehumidifierZ4TowerTop,
                      powerApparentDehumidifierZ4TowerTop],
                    ["kW", "kvar", "kVA"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电能",
                    ["Wp", "Wq"],
                    [energyActiveDehumidifierZ4TowerTop, energyReactiveDehumidifierZ4TowerTop],
                    ["kWh", "kvarh"]
                  )
                }}
                <br />
                {{ assembleTooltip_simpleKeyValue("频率", frequencyDehumidifierZ4TowerTop, "Hz") }}
              </div>
              <div :class="errorZ4TowerTop" class="state-info bottom-pos" @dblclick="hrefToScenario('7067615d-40d3-40be-808a-a1e64da9852a')"
                v-loading="stationNameLoadingDict['stationT3']">
                <p>
                  <span class="bold">Z4上塔T3除湿机</span>
                  <span :class="runningClassZ4TowerTop" class="valve-sign"></span>
                </p>
                <p>
                  <span>电流</span>
                  <span>{{ currentADehumidifierZ4TowerTop | toFixed }}A {{ currentBDehumidifierZ4TowerTop | toFixed }}A
                    {{ currentCDehumidifierZ4TowerTop | toFixed }}A</span>
                </p>
                <p>
                  <span>电压</span>
                  <span>{{ voltageABDehumidifierZ4TowerTop | toFixed }}V {{ voltageBCDehumidifierZ4TowerTop | toFixed
                  }}V
                    {{ voltageACDehumidifierZ4TowerTop | toFixed }}V
                  </span>
                </p>
                <p>
                  <span>功率</span>
                  <span>{{ powerActiveDehumidifierZ4TowerTop | toFixed }}kW {{ powerReactiveDehumidifierZ4TowerTop |
                    toFixed }}Kvar
                    {{ powerApparentDehumidifierZ4TowerTop | toFixed }}kVA
                  </span>
                </p>
                <p>
                  <span>电能</span>
                  <span>{{ energyActiveDehumidifierZ4TowerTop | toFixed }}kWh {{ energyReactiveDehumidifierZ4TowerTop |
                    toFixed }}kvarh</span>
                </p>
                <p>
                  <span>频率</span>
                  <span>{{ frequencyDehumidifierZ4TowerTop | toFixed }}Hz</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <el-tooltip class="station-block station-block-z4-mid" content="Z4中塔T4除湿机" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/jiashao/towerStation/station8"></router-link>
          </el-tooltip>
          <div class="stati sta-z4-mid">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                Z4中塔T4除湿机
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电流",
                    ["Ia", "Ib", "Ic"],
                    [currentADehumidifierZ4TowerMid, currentBDehumidifierZ4TowerMid, currentCDehumidifierZ4TowerMid],
                    ["A", "A", "A"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电压",
                    ["ab", "bc", "ac"],
                    [voltageABDehumidifierZ4TowerMid, voltageBCDehumidifierZ4TowerMid, voltageACDehumidifierZ4TowerMid],
                    ["V", "V", "V"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "功率",
                    ["P", "Q", "S"],
                    [powerActiveDehumidifierZ4TowerMid, powerReactiveDehumidifierZ4TowerMid,
                      powerApparentDehumidifierZ4TowerMid],
                    ["kW", "kvar", "kVA"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电能",
                    ["Wp", "Wq"],
                    [energyActiveDehumidifierZ4TowerMid, energyReactiveDehumidifierZ4TowerMid],
                    ["kWh", "kvarh"]
                  )
                }}
                <br />
                {{ assembleTooltip_simpleKeyValue("频率", frequencyDehumidifierZ4TowerMid, "Hz") }}
              </div>
              <div :class="errorZ4TowerMid" class="state-info right-pos" @dblclick="hrefToScenario('7fadf10b-bf35-4be5-935c-d0478b579707')"
                v-loading="stationNameLoadingDict['stationT4']">
                <p>
                  <span class="bold">Z4中塔T4除湿机</span>
                  <span :class="runningClassZ4TowerMid" class="valve-sign"></span>
                </p>
                <p>
                  <span>电流</span>
                  <span>{{ currentADehumidifierZ4TowerMid | toFixed }}A {{ currentBDehumidifierZ4TowerMid | toFixed }}A
                    {{ currentCDehumidifierZ4TowerMid | toFixed }}A</span>
                </p>
                <p>
                  <span>电压</span>
                  <span>{{ voltageABDehumidifierZ4TowerMid | toFixed }}V {{ voltageBCDehumidifierZ4TowerMid | toFixed
                  }}V
                    {{ voltageACDehumidifierZ4TowerMid | toFixed }}V
                  </span>
                </p>
                <p>
                  <span>功率</span>
                  <span>{{ powerActiveDehumidifierZ4TowerMid | toFixed }}kW {{ powerReactiveDehumidifierZ4TowerMid |
                    toFixed }}Kvar
                    {{ powerApparentDehumidifierZ4TowerMid | toFixed }}kVA
                  </span>
                </p>
                <p>
                  <span>电能</span>
                  <span>{{ energyActiveDehumidifierZ4TowerMid | toFixed }}kWh {{ energyReactiveDehumidifierZ4TowerMid |
                    toFixed }}kvarh</span>
                </p>
                <p>
                  <span>频率</span>
                  <span>{{ frequencyDehumidifierZ4TowerMid | toFixed }}Hz</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <el-tooltip class="station-block station-block-z5-top" content="Z5上塔T5除湿机" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/jiashao/towerStation/station12"></router-link>
          </el-tooltip>
          <div class="stati sta-z5-top">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                Z5上塔T5除湿机
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电流",
                    ["Ia", "Ib", "Ic"],
                    [currentADehumidifierZ5TowerTop, currentBDehumidifierZ5TowerTop, currentCDehumidifierZ5TowerTop],
                    ["A", "A", "A"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电压",
                    ["ab", "bc", "ac"],
                    [voltageABDehumidifierZ5TowerTop, voltageBCDehumidifierZ5TowerTop, voltageACDehumidifierZ5TowerTop],
                    ["V", "V", "V"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "功率",
                    ["P", "Q", "S"],
                    [powerActiveDehumidifierZ5TowerTop, powerReactiveDehumidifierZ5TowerTop,
                      powerApparentDehumidifierZ5TowerTop],
                    ["kW", "kvar", "kVA"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电能",
                    ["Wp", "Wq"],
                    [energyActiveDehumidifierZ5TowerTop, energyReactiveDehumidifierZ5TowerTop],
                    ["kWh", "kvarh"]
                  )
                }}
                <br />
                {{ assembleTooltip_simpleKeyValue("频率", frequencyDehumidifierZ5TowerTop, "Hz") }}
              </div>
              <div :class="errorZ5TowerTop" class="state-info bottom-pos" @dblclick="hrefToScenario('851ed832-222e-4abc-948f-c392114325df')"
                v-loading="stationNameLoadingDict['stationT5']">
                <p>
                  <span class="bold">Z5上塔T5除湿机</span>
                  <span :class="runningClassZ5TowerTop" class="valve-sign"></span>
                </p>
                <p>
                  <span>电流</span>
                  <span>{{ currentADehumidifierZ5TowerTop | toFixed }}A {{ currentBDehumidifierZ5TowerTop | toFixed }}A
                    {{ currentCDehumidifierZ5TowerTop | toFixed }}A</span>
                </p>
                <p>
                  <span>电压</span>
                  <span>{{ voltageABDehumidifierZ5TowerTop | toFixed }}V {{ voltageBCDehumidifierZ5TowerTop | toFixed
                  }}V
                    {{ voltageACDehumidifierZ5TowerTop | toFixed }}V
                  </span>
                </p>
                <p>
                  <span>功率</span>
                  <span>{{ powerActiveDehumidifierZ5TowerTop | toFixed }}kW {{ powerReactiveDehumidifierZ5TowerTop |
                    toFixed }}Kvar
                    {{ powerApparentDehumidifierZ5TowerTop | toFixed }}kVA
                  </span>
                </p>
                <p>
                  <span>电能</span>
                  <span>{{ energyActiveDehumidifierZ5TowerTop | toFixed }}kWh {{ energyReactiveDehumidifierZ5TowerTop |
                    toFixed }}kvarh</span>
                </p>
                <p>
                  <span>频率</span>
                  <span>{{ frequencyDehumidifierZ5TowerTop | toFixed }}Hz</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <el-tooltip class="station-block station-block-z5-mid" content="Z5中塔T6除湿机" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/jiashao/towerStation/station6"></router-link>
          </el-tooltip>
          <div class="stati sta-z5-mid">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                Z5中塔T6除湿机
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电流",
                    ["Ia", "Ib", "Ic"],
                    [currentADehumidifierZ5TowerMid, currentBDehumidifierZ5TowerMid, currentCDehumidifierZ5TowerMid],
                    ["A", "A", "A"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电压",
                    ["ab", "bc", "ac"],
                    [voltageABDehumidifierZ5TowerMid, voltageBCDehumidifierZ5TowerMid, voltageACDehumidifierZ5TowerMid],
                    ["V", "V", "V"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "功率",
                    ["P", "Q", "S"],
                    [powerActiveDehumidifierZ5TowerMid, powerReactiveDehumidifierZ5TowerMid,
                      powerApparentDehumidifierZ5TowerMid],
                    ["kW", "kvar", "kVA"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电能",
                    ["Wp", "Wq"],
                    [energyActiveDehumidifierZ5TowerMid, energyReactiveDehumidifierZ5TowerMid],
                    ["kWh", "kvarh"]
                  )
                }}
                <br />
                {{ assembleTooltip_simpleKeyValue("频率", frequencyDehumidifierZ5TowerMid, "Hz") }}
              </div>
              <div :class="errorZ5TowerMid" class="state-info right-pos" @dblclick="hrefToScenario('079371d1-b4a1-45cb-a63d-fb00b82a6bd0')"
                v-loading="stationNameLoadingDict['stationT6']">
                <p>
                  <span class="bold">Z5中塔T6除湿机</span>
                  <span :class="runningClassZ5TowerMid" class="valve-sign"></span>
                </p>
                <p>
                  <span>电流</span>
                  <span>{{ currentADehumidifierZ5TowerMid | toFixed }}A {{ currentBDehumidifierZ5TowerMid | toFixed }}A
                    {{ currentCDehumidifierZ5TowerMid | toFixed }}A</span>
                </p>
                <p>
                  <span>电压</span>
                  <span>{{ voltageABDehumidifierZ5TowerMid | toFixed }}V {{ voltageBCDehumidifierZ5TowerMid | toFixed
                  }}V
                    {{ voltageACDehumidifierZ5TowerMid | toFixed }}V
                  </span>
                </p>
                <p>
                  <span>功率</span>
                  <span>{{ powerActiveDehumidifierZ5TowerMid | toFixed }}kW {{ powerReactiveDehumidifierZ5TowerMid |
                    toFixed }}Kvar
                    {{ powerApparentDehumidifierZ5TowerMid | toFixed }}kVA
                  </span>
                </p>
                <p>
                  <span>电能</span>
                  <span>{{ energyActiveDehumidifierZ5TowerMid | toFixed }}kWh {{ energyReactiveDehumidifierZ5TowerMid |
                    toFixed }}kvarh</span>
                </p>
                <p>
                  <span>频率</span>
                  <span>{{ frequencyDehumidifierZ5TowerMid | toFixed }}Hz</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <el-tooltip class="station-block station-block-rigidhinge-up" content="J3-R刚性铰J1/J2除湿机" effect="light"
            placement="top">
            <router-link class="iconfont iconshebei" to="/jiashao/rigidHingeStation/station23"></router-link>
          </el-tooltip>
          <div class="stati sta-rigidhinge-up-up">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                J3-R刚性铰J1除湿机
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电流",
                    ["Ia", "Ib", "Ic"],
                    [currentADehumidifierRigidHingeJ1, currentBDehumidifierRigidHingeJ1, currentCDehumidifierRigidHingeJ1],
                    ["A", "A", "A"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电压",
                    ["ab", "bc", "ac"],
                    [voltageABDehumidifierRigidHingeJ1, voltageBCDehumidifierRigidHingeJ1,
                      voltageACDehumidifierRigidHingeJ1],
                    ["V", "V", "V"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "功率",
                    ["P", "Q", "S"],
                    [powerActiveDehumidifierRigidHingeJ1, powerReactiveDehumidifierRigidHingeJ1,
                      powerApparentDehumidifierRigidHingeJ1],
                    ["kW", "kvar", "kVA"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电能",
                    ["Wp", "Wq"],
                    [energyActiveDehumidifierRigidHingeJ1, energyReactiveDehumidifierRigidHingeJ1],
                    ["kWh", "kvarh"]
                  )
                }}
                <br />
                {{ assembleTooltip_simpleKeyValue("频率", frequencyDehumidifierRigidHingeJ1, "Hz") }}
              </div>
              <div :class="errorRigidHingeJ3RJ1" class="state-info bottom-left-pos" @dblclick="hrefToScenario('abc09b72-7ca0-4358-b323-b0929933b265')"
                v-loading="stationNameLoadingDict['stationJ1']">
                <p>
                  <span class="bold">J3-R刚性铰J1除湿机</span>
                  <span :class="runningClassRigidHingeJ3RJ1" class="valve-sign"></span>
                </p>
                <p>
                  <span>电流</span>
                  <span>{{ currentADehumidifierRigidHingeJ1 | toFixed }}A {{ currentBDehumidifierRigidHingeJ1 | toFixed
                  }}A
                    {{ currentCDehumidifierRigidHingeJ1 | toFixed }}A</span>
                </p>
                <p>
                  <span>电压</span>
                  <span>{{ voltageABDehumidifierRigidHingeJ1 | toFixed }}V {{ voltageBCDehumidifierRigidHingeJ1 |
                    toFixed }}V
                    {{ voltageACDehumidifierRigidHingeJ1 | toFixed }}V
                  </span>
                </p>
                <p>
                  <span>功率</span>
                  <span>{{ powerActiveDehumidifierRigidHingeJ1 | toFixed }}kW {{ powerReactiveDehumidifierRigidHingeJ1 |
                    toFixed }}Kvar
                    {{ powerApparentDehumidifierRigidHingeJ1 | toFixed }}kVA
                  </span>
                </p>
                <p>
                  <span>电能</span>
                  <span>{{ energyActiveDehumidifierRigidHingeJ1 | toFixed }}kWh {{
                    energyReactiveDehumidifierRigidHingeJ1 | toFixed }}kvarh</span>
                </p>
                <p>
                  <span>频率</span>
                  <span>{{ frequencyDehumidifierRigidHingeJ1 | toFixed }}Hz</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="stati sta-rigidhinge-up-down">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                J3-R刚性铰J2除湿机
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电流",
                    ["Ia", "Ib", "Ic"],
                    [currentADehumidifierRigidHingeJ2, currentBDehumidifierRigidHingeJ2, currentCDehumidifierRigidHingeJ2],
                    ["A", "A", "A"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电压",
                    ["ab", "bc", "ac"],
                    [voltageABDehumidifierRigidHingeJ2, voltageBCDehumidifierRigidHingeJ2,
                      voltageACDehumidifierRigidHingeJ2],
                    ["V", "V", "V"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "功率",
                    ["P", "Q", "S"],
                    [powerActiveDehumidifierRigidHingeJ2, powerReactiveDehumidifierRigidHingeJ2,
                      powerApparentDehumidifierRigidHingeJ2],
                    ["kW", "kvar", "kVA"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电能",
                    ["Wp", "Wq"],
                    [energyActiveDehumidifierRigidHingeJ2, energyReactiveDehumidifierRigidHingeJ2],
                    ["kWh", "kvarh"]
                  )
                }}
                <br />
                {{ assembleTooltip_simpleKeyValue("频率", frequencyDehumidifierRigidHingeJ2, "Hz") }}
              </div>
              <div :class="errorRigidHingeJ3RJ2" class="state-info top-left-pos" @dblclick="hrefToScenario('5d79eb49-1877-4ebc-ae8d-963e4e15b090')"
                v-loading="stationNameLoadingDict['stationJ2']">
                <p>
                  <span class="bold">J3-R刚性铰J2除湿机</span>
                  <span :class="runningClassRigidHingeJ3RJ2" class="valve-sign"></span>
                </p>
                <p>
                  <span>电流</span>
                  <span>{{ currentADehumidifierRigidHingeJ2 | toFixed }}A {{ currentBDehumidifierRigidHingeJ2 | toFixed
                  }}A
                    {{ currentCDehumidifierRigidHingeJ2 | toFixed }}A</span>
                </p>
                <p>
                  <span>电压</span>
                  <span>{{ voltageABDehumidifierRigidHingeJ2 | toFixed }}V {{ voltageBCDehumidifierRigidHingeJ2 |
                    toFixed }}V
                    {{ voltageACDehumidifierRigidHingeJ2 | toFixed }}V
                  </span>
                </p>
                <p>
                  <span>功率</span>
                  <span>{{ powerActiveDehumidifierRigidHingeJ2 | toFixed }}kW {{ powerReactiveDehumidifierRigidHingeJ2 |
                    toFixed }}Kvar
                    {{ powerApparentDehumidifierRigidHingeJ2 | toFixed }}kVA
                  </span>
                </p>
                <p>
                  <span>电能</span>
                  <span>{{ energyActiveDehumidifierRigidHingeJ2 | toFixed }}kWh {{
                    energyReactiveDehumidifierRigidHingeJ2 | toFixed }}kvarh</span>
                </p>
                <p>
                  <span>频率</span>
                  <span>{{ frequencyDehumidifierRigidHingeJ2 | toFixed }}Hz</span>
                </p>
              </div>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>

    <div class="main-cable" v-loading="loading">
      <div class="cable-title">
        <h2>绍兴侧塔柱</h2>
      </div>
      <div class="cable-main">
        <div class="legend">
          <!-- <div class="sensor1">排气口</div>
          <div class="sensor2">进气口</div> -->
        </div>
        <div class="legend-station">
          <i class="iconfont iconshebei"></i>
          <span>除湿机</span>
        </div>
        <div class="legend-right">
          <div class="running">设备运行</div>
          <div class="stopped">设备停止</div>
          <div class="default">数据中断</div>
        </div>
        <div class="dir left-dir">
          <i class="iconfont icongeo-arrow-left"></i>
          <span class="dir-text">嘉兴</span>
        </div>
        <div class="dir right-dir">
          <i class="iconfont icongeo-arrow-left-copy"></i>
          <span class="dir-text">绍兴</span>
        </div>
        <div class="cable-img image-reversed">
          <div class="tower-name tower-name-z6">Z6</div>
          <div class="tower-name tower-name-z7">Z7</div>
          <div class="tower-name tower-name-z8">Z8</div>
          <el-tooltip class="station-block station-block-rigidhinge-down" content="J3-L刚性铰J3/J4除湿机" effect="light"
            placement="top">
            <router-link class="iconfont iconshebei" to="/jiashao/rigidHingeStation/station22"></router-link>
          </el-tooltip>
          <div class="stati sta-rigidhinge-down-up">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                J3-L刚性铰J3除湿机
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电流",
                    ["Ia", "Ib", "Ic"],
                    [currentADehumidifierRigidHingeJ3, currentBDehumidifierRigidHingeJ3, currentCDehumidifierRigidHingeJ3],
                    ["A", "A", "A"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电压",
                    ["ab", "bc", "ac"],
                    [voltageABDehumidifierRigidHingeJ3, voltageBCDehumidifierRigidHingeJ3,
                      voltageACDehumidifierRigidHingeJ3],
                    ["V", "V", "V"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "功率",
                    ["P", "Q", "S"],
                    [powerActiveDehumidifierRigidHingeJ3, powerReactiveDehumidifierRigidHingeJ3,
                      powerApparentDehumidifierRigidHingeJ3],
                    ["kW", "kvar", "kVA"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电能",
                    ["Wp", "Wq"],
                    [energyActiveDehumidifierRigidHingeJ3, energyReactiveDehumidifierRigidHingeJ3],
                    ["kWh", "kvarh"]
                  )
                }}
                <br />
                {{ assembleTooltip_simpleKeyValue("频率", frequencyDehumidifierRigidHingeJ3, "Hz") }}
              </div>
              <div :class="errorRigidHingeJ3LJ3" class="state-info bottom-right-pos" @dblclick="hrefToScenario('1e8f508b-e537-467b-a117-88e9f67a1212')"
                v-loading="stationNameLoadingDict['stationJ3']">
                <p>
                  <span class="bold">J3-L刚性铰J3除湿机</span>
                  <span :class="runningClassRigidHingeJ3LJ3" class="valve-sign"></span>
                </p>
                <p>
                  <span>电流</span>
                  <span>{{ currentADehumidifierRigidHingeJ3 | toFixed }}A {{ currentBDehumidifierRigidHingeJ3 | toFixed
                  }}A
                    {{ currentCDehumidifierRigidHingeJ3 | toFixed }}A</span>
                </p>
                <p>
                  <span>电压</span>
                  <span>{{ voltageABDehumidifierRigidHingeJ3 | toFixed }}V {{ voltageBCDehumidifierRigidHingeJ3 |
                    toFixed }}V
                    {{ voltageACDehumidifierRigidHingeJ3 | toFixed }}V
                  </span>
                </p>
                <p>
                  <span>功率</span>
                  <span>{{ powerActiveDehumidifierRigidHingeJ3 | toFixed }}kW {{ powerReactiveDehumidifierRigidHingeJ3 |
                    toFixed }}Kvar
                    {{ powerApparentDehumidifierRigidHingeJ3 | toFixed }}kVA
                  </span>
                </p>
                <p>
                  <span>电能</span>
                  <span>{{ energyActiveDehumidifierRigidHingeJ3 | toFixed }}kWh {{
                    energyReactiveDehumidifierRigidHingeJ3 | toFixed }}kvarh</span>
                </p>
                <p>
                  <span>频率</span>
                  <span>{{ frequencyDehumidifierRigidHingeJ3 | toFixed }}Hz</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="stati sta-rigidhinge-down-down">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                J3-L刚性铰J4除湿机
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电流",
                    ["Ia", "Ib", "Ic"],
                    [currentADehumidifierRigidHingeJ4, currentBDehumidifierRigidHingeJ4, currentCDehumidifierRigidHingeJ4],
                    ["A", "A", "A"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电压",
                    ["ab", "bc", "ac"],
                    [voltageABDehumidifierRigidHingeJ4, voltageBCDehumidifierRigidHingeJ4,
                      voltageACDehumidifierRigidHingeJ4],
                    ["V", "V", "V"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "功率",
                    ["P", "Q", "S"],
                    [powerActiveDehumidifierRigidHingeJ4, powerReactiveDehumidifierRigidHingeJ4,
                      powerApparentDehumidifierRigidHingeJ4],
                    ["kW", "kvar", "kVA"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电能",
                    ["Wp", "Wq"],
                    [energyActiveDehumidifierRigidHingeJ4, energyReactiveDehumidifierRigidHingeJ4],
                    ["kWh", "kvarh"]
                  )
                }}
                <br />
                {{ assembleTooltip_simpleKeyValue("频率", frequencyDehumidifierRigidHingeJ4, "Hz") }}
              </div>
              <div :class="errorRigidHingeJ3LJ4" class="state-info top-right-pos" @dblclick="hrefToScenario('a955afa1-9ec0-49bb-8ea7-7f4804d383d7')"
                v-loading="stationNameLoadingDict['stationJ4']">
                <p>
                  <span class="bold">J3-L刚性铰J4除湿机</span>
                  <span :class="runningClassRigidHingeJ3LJ4" class="valve-sign"></span>
                </p>
                <p>
                  <span>电流</span>
                  <span>{{ currentADehumidifierRigidHingeJ4 | toFixed }}A {{ currentBDehumidifierRigidHingeJ4 | toFixed
                  }}A
                    {{ currentCDehumidifierRigidHingeJ4 | toFixed }}A</span>
                </p>
                <p>
                  <span>电压</span>
                  <span>{{ voltageABDehumidifierRigidHingeJ4 | toFixed }}V {{ voltageBCDehumidifierRigidHingeJ4 |
                    toFixed }}V
                    {{ voltageACDehumidifierRigidHingeJ4 | toFixed }}V
                  </span>
                </p>
                <p>
                  <span>功率</span>
                  <span>{{ powerActiveDehumidifierRigidHingeJ4 | toFixed }}kW {{ powerReactiveDehumidifierRigidHingeJ4 |
                    toFixed }}Kvar
                    {{ powerApparentDehumidifierRigidHingeJ4 | toFixed }}kVA
                  </span>
                </p>
                <p>
                  <span>电能</span>
                  <span>{{ energyActiveDehumidifierRigidHingeJ4 | toFixed }}kWh {{
                    energyReactiveDehumidifierRigidHingeJ4 | toFixed }}kvarh</span>
                </p>
                <p>
                  <span>频率</span>
                  <span>{{ frequencyDehumidifierRigidHingeJ4 | toFixed }}Hz</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <el-tooltip class="station-block station-block-z6-top" content="Z6上塔T7除湿机" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/jiashao/towerStation/station7"></router-link>
          </el-tooltip>
          <div class="stati sta-z6-top">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                Z6上塔T7除湿机
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电流",
                    ["Ia", "Ib", "Ic"],
                    [currentADehumidifierZ6TowerTop, currentBDehumidifierZ6TowerTop, currentCDehumidifierZ6TowerTop],
                    ["A", "A", "A"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电压",
                    ["ab", "bc", "ac"],
                    [voltageABDehumidifierZ6TowerTop, voltageBCDehumidifierZ6TowerTop, voltageACDehumidifierZ6TowerTop],
                    ["V", "V", "V"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "功率",
                    ["P", "Q", "S"],
                    [powerActiveDehumidifierZ6TowerTop, powerReactiveDehumidifierZ6TowerTop,
                      powerApparentDehumidifierZ6TowerTop],
                    ["kW", "kvar", "kVA"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电能",
                    ["Wp", "Wq"],
                    [energyActiveDehumidifierZ6TowerTop, energyReactiveDehumidifierZ6TowerTop],
                    ["kWh", "kvarh"]
                  )
                }}
                <br />
                {{ assembleTooltip_simpleKeyValue("频率", frequencyDehumidifierZ6TowerTop, "Hz") }}
              </div>
              <div :class="errorZ6TowerTop" class="state-info bottom-pos" @dblclick="hrefToScenario('1be2ccc5-5f35-47a8-9950-d7a02ddccf02')"
                v-loading="stationNameLoadingDict['stationT7']">
                <p>
                  <span class="bold">Z6上塔T7除湿机</span>
                  <span :class="runningClassZ6TowerTop" class="valve-sign"></span>
                </p>
                <p>
                  <span>电流</span>
                  <span>{{ currentADehumidifierZ6TowerTop | toFixed }}A {{ currentBDehumidifierZ6TowerTop | toFixed }}A
                    {{ currentCDehumidifierZ6TowerTop | toFixed }}A</span>
                </p>
                <p>
                  <span>电压</span>
                  <span>{{ voltageABDehumidifierZ6TowerTop | toFixed }}V {{ voltageBCDehumidifierZ6TowerTop | toFixed
                  }}V
                    {{ voltageACDehumidifierZ6TowerTop | toFixed }}V
                  </span>
                </p>
                <p>
                  <span>功率</span>
                  <span>{{ powerActiveDehumidifierZ6TowerTop | toFixed }}kW {{ powerReactiveDehumidifierZ6TowerTop |
                    toFixed }}Kvar
                    {{ powerApparentDehumidifierZ6TowerTop | toFixed }}kVA
                  </span>
                </p>
                <p>
                  <span>电能</span>
                  <span>{{ energyActiveDehumidifierZ6TowerTop | toFixed }}kWh {{ energyReactiveDehumidifierZ6TowerTop |
                    toFixed }}kvarh</span>
                </p>
                <p>
                  <span>频率</span>
                  <span>{{ frequencyDehumidifierZ6TowerTop | toFixed }}Hz</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <el-tooltip class="station-block station-block-z6-mid" content="Z6中塔T8除湿机" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/jiashao/towerStation/station16"></router-link>
          </el-tooltip>
          <div class="stati sta-z6-mid">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                Z6中塔T8除湿机
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电流",
                    ["Ia", "Ib", "Ic"],
                    [currentADehumidifierZ6TowerMid, currentBDehumidifierZ6TowerMid, currentCDehumidifierZ6TowerMid],
                    ["A", "A", "A"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电压",
                    ["ab", "bc", "ac"],
                    [voltageABDehumidifierZ6TowerMid, voltageBCDehumidifierZ6TowerMid, voltageACDehumidifierZ6TowerMid],
                    ["V", "V", "V"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "功率",
                    ["P", "Q", "S"],
                    [powerActiveDehumidifierZ6TowerMid, powerReactiveDehumidifierZ6TowerMid,
                      powerApparentDehumidifierZ6TowerMid],
                    ["kW", "kvar", "kVA"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电能",
                    ["Wp", "Wq"],
                    [energyActiveDehumidifierZ6TowerMid, energyReactiveDehumidifierZ6TowerMid],
                    ["kWh", "kvarh"]
                  )
                }}
                <br />
                {{ assembleTooltip_simpleKeyValue("频率", frequencyDehumidifierZ6TowerMid, "Hz") }}
              </div>
              <div :class="errorZ6TowerMid" class="state-info left-pos" @dblclick="hrefToScenario('f5f7ec2d-7fab-46d5-812d-7270c69b34aa')"
                v-loading="stationNameLoadingDict['stationT8']">
                <p>
                  <span class="bold">Z6中塔T8除湿机</span>
                  <span :class="runningClassZ6TowerMid" class="valve-sign"></span>
                </p>
                <p>
                  <span>电流</span>
                  <span>{{ currentADehumidifierZ6TowerMid | toFixed }}A {{ currentBDehumidifierZ6TowerMid | toFixed }}A
                    {{ currentCDehumidifierZ6TowerMid | toFixed }}A</span>
                </p>
                <p>
                  <span>电压</span>
                  <span>{{ voltageABDehumidifierZ6TowerMid | toFixed }}V {{ voltageBCDehumidifierZ6TowerMid | toFixed
                  }}V
                    {{ voltageACDehumidifierZ6TowerMid | toFixed }}V
                  </span>
                </p>
                <p>
                  <span>功率</span>
                  <span>{{ powerActiveDehumidifierZ6TowerMid | toFixed }}kW {{ powerReactiveDehumidifierZ6TowerMid |
                    toFixed }}Kvar
                    {{ powerApparentDehumidifierZ6TowerMid | toFixed }}kVA
                  </span>
                </p>
                <p>
                  <span>电能</span>
                  <span>{{ energyActiveDehumidifierZ6TowerMid | toFixed }}kWh {{ energyReactiveDehumidifierZ6TowerMid |
                    toFixed }}kvarh</span>
                </p>
                <p>
                  <span>频率</span>
                  <span>{{ frequencyDehumidifierZ6TowerMid | toFixed }}Hz</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <el-tooltip class="station-block station-block-z7-top" content="Z7上塔T9除湿机" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/jiashao/towerStation/station3"></router-link>
          </el-tooltip>
          <div class="stati sta-z7-top">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                Z7上塔T9除湿机
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电流",
                    ["Ia", "Ib", "Ic"],
                    [currentADehumidifierZ7TowerTop, currentBDehumidifierZ7TowerTop, currentCDehumidifierZ7TowerTop],
                    ["A", "A", "A"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电压",
                    ["ab", "bc", "ac"],
                    [voltageABDehumidifierZ7TowerTop, voltageBCDehumidifierZ7TowerTop, voltageACDehumidifierZ7TowerTop],
                    ["V", "V", "V"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "功率",
                    ["P", "Q", "S"],
                    [powerActiveDehumidifierZ7TowerTop, powerReactiveDehumidifierZ7TowerTop,
                      powerApparentDehumidifierZ7TowerTop],
                    ["kW", "kvar", "kVA"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电能",
                    ["Wp", "Wq"],
                    [energyActiveDehumidifierZ7TowerTop, energyReactiveDehumidifierZ7TowerTop],
                    ["kWh", "kvarh"]
                  )
                }}
                <br />
                {{ assembleTooltip_simpleKeyValue("频率", frequencyDehumidifierZ7TowerTop, "Hz") }}
              </div>
              <div :class="errorZ7TowerTop" class="state-info bottom-pos" @dblclick="hrefToScenario('bb52c2e4-338b-4b07-b7dd-6d8d70c5bd6d')"
                v-loading="stationNameLoadingDict['stationT9']">
                <p>
                  <span class="bold">Z7上塔T9除湿机</span>
                  <span :class="runningClassZ7TowerTop" class="valve-sign"></span>
                </p>
                <p>
                  <span>电流</span>
                  <span>{{ currentADehumidifierZ7TowerTop | toFixed }}A {{ currentBDehumidifierZ7TowerTop | toFixed }}A
                    {{ currentCDehumidifierZ7TowerTop | toFixed }}A</span>
                </p>
                <p>
                  <span>电压</span>
                  <span>{{ voltageABDehumidifierZ7TowerTop | toFixed }}V {{ voltageBCDehumidifierZ7TowerTop | toFixed
                  }}V
                    {{ voltageACDehumidifierZ7TowerTop | toFixed }}V
                  </span>
                </p>
                <p>
                  <span>功率</span>
                  <span>{{ powerActiveDehumidifierZ7TowerTop | toFixed }}kW {{ powerReactiveDehumidifierZ7TowerTop |
                    toFixed }}Kvar
                    {{ powerApparentDehumidifierZ7TowerTop | toFixed }}kVA
                  </span>
                </p>
                <p>
                  <span>电能</span>
                  <span>{{ energyActiveDehumidifierZ7TowerTop | toFixed }}kWh {{ energyReactiveDehumidifierZ7TowerTop |
                    toFixed }}kvarh</span>
                </p>
                <p>
                  <span>频率</span>
                  <span>{{ frequencyDehumidifierZ7TowerTop | toFixed }}Hz</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <el-tooltip class="station-block station-block-z7-mid" content="Z7中塔T10除湿机" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/jiashao/towerStation/station10"></router-link>
          </el-tooltip>
          <div class="stati sta-z7-mid">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                Z7中塔T10除湿机
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电流",
                    ["Ia", "Ib", "Ic"],
                    [currentADehumidifierZ7TowerMid, currentBDehumidifierZ7TowerMid, currentCDehumidifierZ7TowerMid],
                    ["A", "A", "A"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电压",
                    ["ab", "bc", "ac"],
                    [voltageABDehumidifierZ7TowerMid, voltageBCDehumidifierZ7TowerMid, voltageACDehumidifierZ7TowerMid],
                    ["V", "V", "V"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "功率",
                    ["P", "Q", "S"],
                    [powerActiveDehumidifierZ7TowerMid, powerReactiveDehumidifierZ7TowerMid,
                      powerApparentDehumidifierZ7TowerMid],
                    ["kW", "kvar", "kVA"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电能",
                    ["Wp", "Wq"],
                    [energyActiveDehumidifierZ7TowerMid, energyReactiveDehumidifierZ7TowerMid],
                    ["kWh", "kvarh"]
                  )
                }}
                <br />
                {{ assembleTooltip_simpleKeyValue("频率", frequencyDehumidifierZ7TowerMid, "Hz") }}
              </div>
              <div :class="errorZ7TowerMid" class="state-info left-pos" @dblclick="hrefToScenario('c3c889fb-d28c-4ef0-a73d-8d39a1aebd2b')"
                v-loading="stationNameLoadingDict['stationT10']">
                <p>
                  <span class="bold">Z7中塔T10除湿机</span>
                  <span :class="runningClassZ7TowerMid" class="valve-sign"></span>
                </p>
                <p>
                  <span>电流</span>
                  <span>{{ currentADehumidifierZ7TowerMid | toFixed }}A {{ currentBDehumidifierZ7TowerMid | toFixed }}A
                    {{ currentCDehumidifierZ7TowerMid | toFixed }}A</span>
                </p>
                <p>
                  <span>电压</span>
                  <span>{{ voltageABDehumidifierZ7TowerMid | toFixed }}V {{ voltageBCDehumidifierZ7TowerMid | toFixed
                  }}V
                    {{ voltageACDehumidifierZ7TowerMid | toFixed }}V
                  </span>
                </p>
                <p>
                  <span>功率</span>
                  <span>{{ powerActiveDehumidifierZ7TowerMid | toFixed }}kW {{ powerReactiveDehumidifierZ7TowerMid |
                    toFixed }}Kvar
                    {{ powerApparentDehumidifierZ7TowerMid | toFixed }}kVA
                  </span>
                </p>
                <p>
                  <span>电能</span>
                  <span>{{ energyActiveDehumidifierZ7TowerMid | toFixed }}kWh {{ energyReactiveDehumidifierZ7TowerMid |
                    toFixed }}kvarh</span>
                </p>
                <p>
                  <span>频率</span>
                  <span>{{ frequencyDehumidifierZ7TowerMid | toFixed }}Hz</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <el-tooltip class="station-block station-block-z8-top" content="Z8上塔T11除湿机" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/jiashao/towerStation/station4"></router-link>
          </el-tooltip>
          <div class="stati sta-z8-top">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                Z8上塔T11除湿机
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电流",
                    ["Ia", "Ib", "Ic"],
                    [currentADehumidifierZ8TowerTop, currentBDehumidifierZ8TowerTop, currentCDehumidifierZ8TowerTop],
                    ["A", "A", "A"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电压",
                    ["ab", "bc", "ac"],
                    [voltageABDehumidifierZ8TowerTop, voltageBCDehumidifierZ8TowerTop, voltageACDehumidifierZ8TowerTop],
                    ["V", "V", "V"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "功率",
                    ["P", "Q", "S"],
                    [powerActiveDehumidifierZ8TowerTop, powerReactiveDehumidifierZ8TowerTop,
                      powerApparentDehumidifierZ8TowerTop],
                    ["kW", "kvar", "kVA"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电能",
                    ["Wp", "Wq"],
                    [energyActiveDehumidifierZ8TowerTop, energyReactiveDehumidifierZ8TowerTop],
                    ["kWh", "kvarh"]
                  )
                }}
                <br />
                {{ assembleTooltip_simpleKeyValue("频率", frequencyDehumidifierZ8TowerTop, "Hz") }}
              </div>
              <div :class="errorZ8TowerTop" class="state-info bottom-pos" @dblclick="hrefToScenario('e9d270a9-5b97-4de2-a1b2-b51504528eb3')"
                v-loading="stationNameLoadingDict['stationT11']">
                <p>
                  <span class="bold">Z8上塔T11除湿机</span>
                  <span :class="runningClassZ8TowerTop" class="valve-sign"></span>
                </p>
                <p>
                  <span>电流</span>
                  <span>{{ currentADehumidifierZ8TowerTop | toFixed }}A {{ currentBDehumidifierZ8TowerTop | toFixed }}A
                    {{ currentCDehumidifierZ8TowerTop | toFixed }}A</span>
                </p>
                <p>
                  <span>电压</span>
                  <span>{{ voltageABDehumidifierZ8TowerTop | toFixed }}V {{ voltageBCDehumidifierZ8TowerTop | toFixed
                  }}V
                    {{ voltageACDehumidifierZ8TowerTop | toFixed }}V
                  </span>
                </p>
                <p>
                  <span>功率</span>
                  <span>{{ powerActiveDehumidifierZ8TowerTop | toFixed }}kW {{ powerReactiveDehumidifierZ8TowerTop |
                    toFixed }}Kvar
                    {{ powerApparentDehumidifierZ8TowerTop | toFixed }}kVA
                  </span>
                </p>
                <p>
                  <span>电能</span>
                  <span>{{ energyActiveDehumidifierZ8TowerTop | toFixed }}kWh {{ energyReactiveDehumidifierZ8TowerTop |
                    toFixed }}kvarh</span>
                </p>
                <p>
                  <span>频率</span>
                  <span>{{ frequencyDehumidifierZ8TowerTop | toFixed }}Hz</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <el-tooltip class="station-block station-block-z8-mid" content="Z8中塔T12除湿机" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/jiashao/towerStation/station29"></router-link>
          </el-tooltip>
          <div class="stati sta-z8-mid">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                Z8中塔T12除湿机
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电流",
                    ["Ia", "Ib", "Ic"],
                    [currentADehumidifierZ8TowerMid, currentBDehumidifierZ8TowerMid, currentCDehumidifierZ8TowerMid],
                    ["A", "A", "A"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电压",
                    ["ab", "bc", "ac"],
                    [voltageABDehumidifierZ8TowerMid, voltageBCDehumidifierZ8TowerMid, voltageACDehumidifierZ8TowerMid],
                    ["V", "V", "V"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "功率",
                    ["P", "Q", "S"],
                    [powerActiveDehumidifierZ8TowerMid, powerReactiveDehumidifierZ8TowerMid,
                      powerApparentDehumidifierZ8TowerMid],
                    ["kW", "kvar", "kVA"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电能",
                    ["Wp", "Wq"],
                    [energyActiveDehumidifierZ8TowerMid, energyReactiveDehumidifierZ8TowerMid],
                    ["kWh", "kvarh"]
                  )
                }}
                <br />
                {{ assembleTooltip_simpleKeyValue("频率", frequencyDehumidifierZ8TowerMid, "Hz") }}
              </div>
              <div :class="errorZ8TowerMid" class="state-info left-pos" @dblclick="hrefToScenario('fa9b782e-cc7a-4938-9ad6-9318c072ac9a')"
                v-loading="stationNameLoadingDict['stationT12']">
                <p>
                  <span class="bold">Z8中塔T12除湿机</span>
                  <span :class="runningClassZ8TowerMid" class="valve-sign"></span>
                </p>
                <p>
                  <span>电流</span>
                  <span>{{ currentADehumidifierZ8TowerMid | toFixed }}A {{ currentBDehumidifierZ8TowerMid | toFixed }}A
                    {{ currentCDehumidifierZ8TowerMid | toFixed }}A</span>
                </p>
                <p>
                  <span>电压</span>
                  <span>{{ voltageABDehumidifierZ8TowerMid | toFixed }}V {{ voltageBCDehumidifierZ8TowerMid | toFixed
                  }}V
                    {{ voltageACDehumidifierZ8TowerMid | toFixed }}V
                  </span>
                </p>
                <p>
                  <span>功率</span>
                  <span>{{ powerActiveDehumidifierZ8TowerMid | toFixed }}kW {{ powerReactiveDehumidifierZ8TowerMid |
                    toFixed }}Kvar
                    {{ powerApparentDehumidifierZ8TowerMid | toFixed }}kVA
                  </span>
                </p>
                <p>
                  <span>电能</span>
                  <span>{{ energyActiveDehumidifierZ8TowerMid | toFixed }}kWh {{ energyReactiveDehumidifierZ8TowerMid |
                    toFixed }}kvarh</span>
                </p>
                <p>
                  <span>频率</span>
                  <span>{{ frequencyDehumidifierZ8TowerMid | toFixed }}Hz</span>
                </p>
              </div>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "gasClamp",
  data() {
    return {
      loading: true,
      timer: null,

      routerPrefix: "jiashao",
      bridgeId: "3b04991c-3662-4948-930e-ac537ed82fd3",

      //humidity, temperature, pressure, flow, volume
      currentADehumidifierZ3TowerTop: "--",
      currentADehumidifierZ3TowerMid: "--",
      currentADehumidifierZ4TowerTop: "--",
      currentADehumidifierZ4TowerMid: "--",
      currentADehumidifierZ5TowerTop: "--",
      currentADehumidifierZ5TowerMid: "--",
      currentADehumidifierZ6TowerTop: "--",
      currentADehumidifierZ6TowerMid: "--",
      currentADehumidifierZ7TowerTop: "--",
      currentADehumidifierZ7TowerMid: "--",
      currentADehumidifierZ8TowerTop: "--",
      currentADehumidifierZ8TowerMid: "--",
      currentBDehumidifierZ3TowerTop: "--",
      currentBDehumidifierZ3TowerMid: "--",
      currentBDehumidifierZ4TowerTop: "--",
      currentBDehumidifierZ4TowerMid: "--",
      currentBDehumidifierZ5TowerTop: "--",
      currentBDehumidifierZ5TowerMid: "--",
      currentBDehumidifierZ6TowerTop: "--",
      currentBDehumidifierZ6TowerMid: "--",
      currentBDehumidifierZ7TowerTop: "--",
      currentBDehumidifierZ7TowerMid: "--",
      currentBDehumidifierZ8TowerTop: "--",
      currentBDehumidifierZ8TowerMid: "--",
      currentCDehumidifierZ3TowerTop: "--",
      currentCDehumidifierZ3TowerMid: "--",
      currentCDehumidifierZ4TowerTop: "--",
      currentCDehumidifierZ4TowerMid: "--",
      currentCDehumidifierZ5TowerTop: "--",
      currentCDehumidifierZ5TowerMid: "--",
      currentCDehumidifierZ6TowerTop: "--",
      currentCDehumidifierZ6TowerMid: "--",
      currentCDehumidifierZ7TowerTop: "--",
      currentCDehumidifierZ7TowerMid: "--",
      currentCDehumidifierZ8TowerTop: "--",
      currentCDehumidifierZ8TowerMid: "--",

      currentADehumidifierRigidHingeJ1: "--",
      currentADehumidifierRigidHingeJ2: "--",
      currentADehumidifierRigidHingeJ3: "--",
      currentADehumidifierRigidHingeJ4: "--",
      currentBDehumidifierRigidHingeJ1: "--",
      currentBDehumidifierRigidHingeJ2: "--",
      currentBDehumidifierRigidHingeJ3: "--",
      currentBDehumidifierRigidHingeJ4: "--",
      currentCDehumidifierRigidHingeJ1: "--",
      currentCDehumidifierRigidHingeJ2: "--",
      currentCDehumidifierRigidHingeJ3: "--",
      currentCDehumidifierRigidHingeJ4: "--",

      voltageABDehumidifierZ3TowerTop: "--",
      voltageABDehumidifierZ3TowerMid: "--",
      voltageABDehumidifierZ4TowerTop: "--",
      voltageABDehumidifierZ4TowerMid: "--",
      voltageABDehumidifierZ5TowerTop: "--",
      voltageABDehumidifierZ5TowerMid: "--",
      voltageABDehumidifierZ6TowerTop: "--",
      voltageABDehumidifierZ6TowerMid: "--",
      voltageABDehumidifierZ7TowerTop: "--",
      voltageABDehumidifierZ7TowerMid: "--",
      voltageABDehumidifierZ8TowerTop: "--",
      voltageABDehumidifierZ8TowerMid: "--",
      voltageBCDehumidifierZ3TowerTop: "--",
      voltageBCDehumidifierZ3TowerMid: "--",
      voltageBCDehumidifierZ4TowerTop: "--",
      voltageBCDehumidifierZ4TowerMid: "--",
      voltageBCDehumidifierZ5TowerTop: "--",
      voltageBCDehumidifierZ5TowerMid: "--",
      voltageBCDehumidifierZ6TowerTop: "--",
      voltageBCDehumidifierZ6TowerMid: "--",
      voltageBCDehumidifierZ7TowerTop: "--",
      voltageBCDehumidifierZ7TowerMid: "--",
      voltageBCDehumidifierZ8TowerTop: "--",
      voltageBCDehumidifierZ8TowerMid: "--",
      voltageACDehumidifierZ3TowerTop: "--",
      voltageACDehumidifierZ3TowerMid: "--",
      voltageACDehumidifierZ4TowerTop: "--",
      voltageACDehumidifierZ4TowerMid: "--",
      voltageACDehumidifierZ5TowerTop: "--",
      voltageACDehumidifierZ5TowerMid: "--",
      voltageACDehumidifierZ6TowerTop: "--",
      voltageACDehumidifierZ6TowerMid: "--",
      voltageACDehumidifierZ7TowerTop: "--",
      voltageACDehumidifierZ7TowerMid: "--",
      voltageACDehumidifierZ8TowerTop: "--",
      voltageACDehumidifierZ8TowerMid: "--",

      voltageABDehumidifierRigidHingeJ1: "--",
      voltageABDehumidifierRigidHingeJ2: "--",
      voltageABDehumidifierRigidHingeJ3: "--",
      voltageABDehumidifierRigidHingeJ4: "--",
      voltageBCDehumidifierRigidHingeJ1: "--",
      voltageBCDehumidifierRigidHingeJ2: "--",
      voltageBCDehumidifierRigidHingeJ3: "--",
      voltageBCDehumidifierRigidHingeJ4: "--",
      voltageACDehumidifierRigidHingeJ1: "--",
      voltageACDehumidifierRigidHingeJ2: "--",
      voltageACDehumidifierRigidHingeJ3: "--",
      voltageACDehumidifierRigidHingeJ4: "--",

      powerActiveDehumidifierZ3TowerTop: "--",
      powerActiveDehumidifierZ3TowerMid: "--",
      powerActiveDehumidifierZ4TowerTop: "--",
      powerActiveDehumidifierZ4TowerMid: "--",
      powerActiveDehumidifierZ5TowerTop: "--",
      powerActiveDehumidifierZ5TowerMid: "--",
      powerActiveDehumidifierZ6TowerTop: "--",
      powerActiveDehumidifierZ6TowerMid: "--",
      powerActiveDehumidifierZ7TowerTop: "--",
      powerActiveDehumidifierZ7TowerMid: "--",
      powerActiveDehumidifierZ8TowerTop: "--",
      powerActiveDehumidifierZ8TowerMid: "--",
      powerReactiveDehumidifierZ3TowerTop: "--",
      powerReactiveDehumidifierZ3TowerMid: "--",
      powerReactiveDehumidifierZ4TowerTop: "--",
      powerReactiveDehumidifierZ4TowerMid: "--",
      powerReactiveDehumidifierZ5TowerTop: "--",
      powerReactiveDehumidifierZ5TowerMid: "--",
      powerReactiveDehumidifierZ6TowerTop: "--",
      powerReactiveDehumidifierZ6TowerMid: "--",
      powerReactiveDehumidifierZ7TowerTop: "--",
      powerReactiveDehumidifierZ7TowerMid: "--",
      powerReactiveDehumidifierZ8TowerTop: "--",
      powerReactiveDehumidifierZ8TowerMid: "--",
      powerApparentDehumidifierZ3TowerTop: "--",
      powerApparentDehumidifierZ3TowerMid: "--",
      powerApparentDehumidifierZ4TowerTop: "--",
      powerApparentDehumidifierZ4TowerMid: "--",
      powerApparentDehumidifierZ5TowerTop: "--",
      powerApparentDehumidifierZ5TowerMid: "--",
      powerApparentDehumidifierZ6TowerTop: "--",
      powerApparentDehumidifierZ6TowerMid: "--",
      powerApparentDehumidifierZ7TowerTop: "--",
      powerApparentDehumidifierZ7TowerMid: "--",
      powerApparentDehumidifierZ8TowerTop: "--",
      powerApparentDehumidifierZ8TowerMid: "--",

      powerActiveDehumidifierRigidHingeJ1: "--",
      powerActiveDehumidifierRigidHingeJ2: "--",
      powerActiveDehumidifierRigidHingeJ3: "--",
      powerActiveDehumidifierRigidHingeJ4: "--",
      powerReactiveDehumidifierRigidHingeJ1: "--",
      powerReactiveDehumidifierRigidHingeJ2: "--",
      powerReactiveDehumidifierRigidHingeJ3: "--",
      powerReactiveDehumidifierRigidHingeJ4: "--",
      powerApparentDehumidifierRigidHingeJ1: "--",
      powerApparentDehumidifierRigidHingeJ2: "--",
      powerApparentDehumidifierRigidHingeJ3: "--",
      powerApparentDehumidifierRigidHingeJ4: "--",

      energyActiveDehumidifierZ3TowerTop: "--",
      energyActiveDehumidifierZ3TowerMid: "--",
      energyActiveDehumidifierZ4TowerTop: "--",
      energyActiveDehumidifierZ4TowerMid: "--",
      energyActiveDehumidifierZ5TowerTop: "--",
      energyActiveDehumidifierZ5TowerMid: "--",
      energyActiveDehumidifierZ6TowerTop: "--",
      energyActiveDehumidifierZ6TowerMid: "--",
      energyActiveDehumidifierZ7TowerTop: "--",
      energyActiveDehumidifierZ7TowerMid: "--",
      energyActiveDehumidifierZ8TowerTop: "--",
      energyActiveDehumidifierZ8TowerMid: "--",
      energyReactiveDehumidifierZ3TowerTop: "--",
      energyReactiveDehumidifierZ3TowerMid: "--",
      energyReactiveDehumidifierZ4TowerTop: "--",
      energyReactiveDehumidifierZ4TowerMid: "--",
      energyReactiveDehumidifierZ5TowerTop: "--",
      energyReactiveDehumidifierZ5TowerMid: "--",
      energyReactiveDehumidifierZ6TowerTop: "--",
      energyReactiveDehumidifierZ6TowerMid: "--",
      energyReactiveDehumidifierZ7TowerTop: "--",
      energyReactiveDehumidifierZ7TowerMid: "--",
      energyReactiveDehumidifierZ8TowerTop: "--",
      energyReactiveDehumidifierZ8TowerMid: "--",

      energyActiveDehumidifierRigidHingeJ1: "--",
      energyActiveDehumidifierRigidHingeJ2: "--",
      energyActiveDehumidifierRigidHingeJ3: "--",
      energyActiveDehumidifierRigidHingeJ4: "--",
      energyReactiveDehumidifierRigidHingeJ1: "--",
      energyReactiveDehumidifierRigidHingeJ2: "--",
      energyReactiveDehumidifierRigidHingeJ3: "--",
      energyReactiveDehumidifierRigidHingeJ4: "--",

      frequencyDehumidifierZ3TowerTop: "--",
      frequencyDehumidifierZ3TowerMid: "--",
      frequencyDehumidifierZ4TowerTop: "--",
      frequencyDehumidifierZ4TowerMid: "--",
      frequencyDehumidifierZ5TowerTop: "--",
      frequencyDehumidifierZ5TowerMid: "--",
      frequencyDehumidifierZ6TowerTop: "--",
      frequencyDehumidifierZ6TowerMid: "--",
      frequencyDehumidifierZ7TowerTop: "--",
      frequencyDehumidifierZ7TowerMid: "--",
      frequencyDehumidifierZ8TowerTop: "--",
      frequencyDehumidifierZ8TowerMid: "--",

      frequencyDehumidifierRigidHingeJ1: "--",
      frequencyDehumidifierRigidHingeJ2: "--",
      frequencyDehumidifierRigidHingeJ3: "--",
      frequencyDehumidifierRigidHingeJ4: "--",

      //running
      runningDehumidifierZ3TowerTop: "--",
      runningDehumidifierZ3TowerMid: "--",
      runningDehumidifierZ4TowerTop: "--",
      runningDehumidifierZ4TowerMid: "--",
      runningDehumidifierZ5TowerTop: "--",
      runningDehumidifierZ5TowerMid: "--",
      runningDehumidifierZ6TowerTop: "--",
      runningDehumidifierZ6TowerMid: "--",
      runningDehumidifierZ7TowerTop: "--",
      runningDehumidifierZ7TowerMid: "--",
      runningDehumidifierZ8TowerTop: "--",
      runningDehumidifierZ8TowerMid: "--",

      runningDehumidifierRigidHingeJ1: "--",
      runningDehumidifierRigidHingeJ2: "--",
      runningDehumidifierRigidHingeJ3: "--",
      runningDehumidifierRigidHingeJ4: "--",

      //malfunction
      malfunctionDehumidifierZ3TowerTop: "--",
      malfunctionDehumidifierZ3TowerMid: "--",
      malfunctionDehumidifierZ4TowerTop: "--",
      malfunctionDehumidifierZ4TowerMid: "--",
      malfunctionDehumidifierZ5TowerTop: "--",
      malfunctionDehumidifierZ5TowerMid: "--",
      malfunctionDehumidifierZ6TowerTop: "--",
      malfunctionDehumidifierZ6TowerMid: "--",
      malfunctionDehumidifierZ7TowerTop: "--",
      malfunctionDehumidifierZ7TowerMid: "--",
      malfunctionDehumidifierZ8TowerTop: "--",
      malfunctionDehumidifierZ8TowerMid: "--",

      malfunctionDehumidifierRigidHingeJ1: "--",
      malfunctionDehumidifierRigidHingeJ2: "--",
      malfunctionDehumidifierRigidHingeJ3: "--",
      malfunctionDehumidifierRigidHingeJ4: "--",

      //error
      errorZ3TowerTop: "--",
      errorZ3TowerMid: "--",
      errorZ4TowerTop: "--",
      errorZ4TowerMid: "--",
      errorZ5TowerTop: "--",
      errorZ5TowerMid: "--",
      errorZ6TowerTop: "--",
      errorZ6TowerMid: "--",
      errorZ7TowerTop: "--",
      errorZ7TowerMid: "--",
      errorZ8TowerTop: "--",
      errorZ8TowerMid: "--",

      errorRigidHingeJ3RJ1: "--",
      errorRigidHingeJ3RJ2: "--",
      errorRigidHingeJ3LJ3: "--",
      errorRigidHingeJ3LJ4: "--",

      //running class
      runningClassZ3TowerTop: "--",
      runningClassZ3TowerMid: "--",
      runningClassZ4TowerTop: "--",
      runningClassZ4TowerMid: "--",
      runningClassZ5TowerTop: "--",
      runningClassZ5TowerMid: "--",
      runningClassZ6TowerTop: "--",
      runningClassZ6TowerMid: "--",
      runningClassZ7TowerTop: "--",
      runningClassZ7TowerMid: "--",
      runningClassZ8TowerTop: "--",
      runningClassZ8TowerMid: "--",

      runningClassRigidHingeJ3RJ1: "--",
      runningClassRigidHingeJ3RJ2: "--",
      runningClassRigidHingeJ3LJ3: "--",
      runningClassRigidHingeJ3LJ4: "--",

      //humidity allowed max

      //humidity tooltip error

      dataNameIdDict: {
        //humidity, temperature
        currentADehumidifierRigidHingeJ1: "6de19259-57d8-40a4-87ca-668145b6956c",
        currentBDehumidifierRigidHingeJ1: "b5a4b2c2-281d-40e2-8f06-4f129cf34933",
        currentCDehumidifierRigidHingeJ1: "32300395-2c48-45e4-ac48-e36b7bf89559",
        currentADehumidifierRigidHingeJ2: "4d82d68a-1763-424c-b4ea-60e01b0381f1",
        currentBDehumidifierRigidHingeJ2: "59b1ab4c-83c7-422e-a3b2-3fbfed16858a",
        currentCDehumidifierRigidHingeJ2: "4f7f2cf8-27cb-46f2-a8ea-1200c4d6fb3e",
        currentADehumidifierRigidHingeJ3: "89722b4c-77ca-472b-9dad-0463bf16e61a",
        currentBDehumidifierRigidHingeJ3: "c880a7d3-d767-48d7-8338-60aad99b93c2",
        currentCDehumidifierRigidHingeJ3: "9647cbe9-074a-484a-b3cf-3bbbca6b8255",
        currentADehumidifierRigidHingeJ4: "a4fb1c96-d24e-4e8f-a368-3eefcfa2f7d1",
        currentBDehumidifierRigidHingeJ4: "34fa28b6-2ebb-479d-aec2-56d6f7ae6d05",
        currentCDehumidifierRigidHingeJ4: "6ba5ef01-1bf8-4ad5-ab6f-a680275c0117",

        currentADehumidifierZ3TowerMid: "284b8f28-6a93-43c4-8cc0-d4aabde1458c",
        currentBDehumidifierZ3TowerMid: "69db9823-518a-4971-b3d4-7376c13c8b21",
        currentCDehumidifierZ3TowerMid: "3aaab576-929f-412a-af2d-203451ca38ae",
        currentADehumidifierZ4TowerMid: "270a90f2-8f8e-435f-9d78-b648ca428edf",
        currentBDehumidifierZ4TowerMid: "869e0598-adaf-448e-9809-13eca3a3c08d",
        currentCDehumidifierZ4TowerMid: "3ba6cbe1-24f4-4c18-80a3-1b2b5e4876f2",
        currentADehumidifierZ5TowerMid: "862f8663-ec5c-444d-aa6a-bcd3007f3932",
        currentBDehumidifierZ5TowerMid: "8828bdbd-8206-42a0-baa6-da3ebb349f32",
        currentCDehumidifierZ5TowerMid: "08c5d449-820c-4362-9339-3cad97d7bc46",
        currentADehumidifierZ6TowerMid: "09adaf0d-e752-47de-bbd7-1357227cf29d",
        currentBDehumidifierZ6TowerMid: "390d7b7c-0d41-4084-abff-6b97b26949d8",
        currentCDehumidifierZ6TowerMid: "ca2c453f-18a7-460b-b499-7a85b5c5a4d7",
        currentADehumidifierZ7TowerMid: "3e01953b-5c95-443a-98fd-7316309b62c6",
        currentBDehumidifierZ7TowerMid: "e7a6ce2e-1e82-4ca1-a724-9ec972c6125a",
        currentCDehumidifierZ7TowerMid: "9aca8aad-8ec6-4c88-9c45-5b5a5ad5356b",
        currentADehumidifierZ8TowerMid: "705db646-20a0-40f2-82c7-fd2de405ea08",
        currentBDehumidifierZ8TowerMid: "24781e3f-6fe5-40ba-a394-cfbba7f5b427",
        currentCDehumidifierZ8TowerMid: "bc20c2ee-0104-41c9-aaf6-2d0ba8794928",
        currentADehumidifierZ3TowerTop: "f98b6523-188d-48db-a723-df1678867269",
        currentBDehumidifierZ3TowerTop: "89e4c267-8740-48de-a26a-d9ccc8e9dd52",
        currentCDehumidifierZ3TowerTop: "1544e74b-ba58-484b-ab99-6d24208de963",
        currentADehumidifierZ4TowerTop: "49dd7fb7-cbd3-4acc-a698-0d803993a8c6",
        currentBDehumidifierZ4TowerTop: "fd5a6a49-0567-433c-be27-152975eeebb9",
        currentCDehumidifierZ4TowerTop: "7ee0f019-9774-455c-96c1-768387636e89",
        currentADehumidifierZ5TowerTop: "29f6d411-e516-4c7a-83dc-cfa05573a765",
        currentBDehumidifierZ5TowerTop: "f222e51a-a504-4cb5-800e-93f2294980a6",
        currentCDehumidifierZ5TowerTop: "9a852145-9be9-4230-a942-4578d32b5563",
        currentADehumidifierZ6TowerTop: "f6fe5d09-a05a-4eb5-a944-ddb3563fa295",
        currentBDehumidifierZ6TowerTop: "10fad6a6-888a-4cd8-9454-a8582af5b55f",
        currentCDehumidifierZ6TowerTop: "9dcad67e-32e4-4b76-b154-116aab489678",
        currentADehumidifierZ7TowerTop: "e14bdeca-a89c-4349-af70-3a79d21ade99",
        currentBDehumidifierZ7TowerTop: "b43a55ce-6b46-44e6-a64b-ffa9faebd062",
        currentCDehumidifierZ7TowerTop: "8bf82fb3-2d33-429e-8c25-6329f4606263",
        currentADehumidifierZ8TowerTop: "e463cfdb-3577-410e-8ccb-d5da428d32e6",
        currentBDehumidifierZ8TowerTop: "0c8c4ce7-f5dd-4e30-aa00-ae38c1c39cff",
        currentCDehumidifierZ8TowerTop: "94e57217-50fd-406f-b4cf-72c835582753",

        voltageABDehumidifierRigidHingeJ1: "711810dc-cc21-480c-990e-989398b9987c",
        voltageACDehumidifierRigidHingeJ1: "34b2b80d-eca4-49cc-a1c6-ad8e7c1a3883",
        voltageBCDehumidifierRigidHingeJ1: "e08a323c-9be3-47e6-a84e-b984b1571378",
        voltageABDehumidifierRigidHingeJ2: "e737c7b6-a4d9-41a9-b57c-3da606852127",
        voltageACDehumidifierRigidHingeJ2: "08fda2a5-40ea-4535-b679-554c1a59ca10",
        voltageBCDehumidifierRigidHingeJ2: "cc5b1a31-17d9-4d30-9f1d-efa66c79000a",
        voltageABDehumidifierRigidHingeJ3: "87ad94c9-d7e4-43b3-a39b-85baac0529e0",
        voltageACDehumidifierRigidHingeJ3: "7a938bfc-0740-4893-9af0-c923a5af6a44",
        voltageBCDehumidifierRigidHingeJ3: "5c7d2e56-2122-4b9d-b26b-c3d04a8e02ab",
        voltageABDehumidifierRigidHingeJ4: "0b6f2fff-5d81-466b-86d4-92665f5dac50",
        voltageACDehumidifierRigidHingeJ4: "012dfc47-6cfe-4091-977d-f762d8ed2702",
        voltageBCDehumidifierRigidHingeJ4: "2a3ca436-ed8a-4ba2-a72c-4389cdb89390",

        voltageABDehumidifierZ3TowerMid: "26f70e58-7da7-49ff-b2d9-dc3751f5b9ad",
        voltageACDehumidifierZ3TowerMid: "d96308b9-d30c-40c3-bb95-f0d91d02407b",
        voltageBCDehumidifierZ3TowerMid: "94e54548-a9e2-4c37-bab8-67e0cb09433b",
        voltageABDehumidifierZ4TowerMid: "1d1d6832-26da-4b16-8377-8181d7f86c52",
        voltageACDehumidifierZ4TowerMid: "a1964328-8055-40d6-a5ff-2f8bf71ef48d",
        voltageBCDehumidifierZ4TowerMid: "9ac151c8-b71a-4485-aa81-6f837f1071d6",
        voltageABDehumidifierZ5TowerMid: "67bce86e-2f74-48f0-9f37-0a9c31241cd2",
        voltageACDehumidifierZ5TowerMid: "1bf5d50e-9d44-4a45-b2f1-362d1c7a7bbf",
        voltageBCDehumidifierZ5TowerMid: "5aa61898-9bcd-49e7-abeb-b6816afcf331",
        voltageABDehumidifierZ6TowerMid: "c8c1fead-39e6-4853-a9ef-d85d0404da9a",
        voltageACDehumidifierZ6TowerMid: "1ffc84ac-c6dd-41d8-aa68-76530d1752db",
        voltageBCDehumidifierZ6TowerMid: "1eafc021-fe44-4a3b-bb45-72b4696154e5",
        voltageABDehumidifierZ7TowerMid: "f38ab420-f7b7-4378-a9ac-f3fac3e43d77",
        voltageACDehumidifierZ7TowerMid: "e2b678b4-ab28-473a-aef1-39b32d424ce4",
        voltageBCDehumidifierZ7TowerMid: "814c1170-5b89-446d-a886-d0654754b71f",
        voltageABDehumidifierZ8TowerMid: "5a88831b-0d83-4ae7-9951-f9a426365408",
        voltageACDehumidifierZ8TowerMid: "8dc7f724-d2f3-4da9-be3d-97888c02897c",
        voltageBCDehumidifierZ8TowerMid: "4ba4486f-8903-4fd2-ba70-7491c69047b1",
        voltageABDehumidifierZ3TowerTop: "68c6f990-7297-400a-91dc-3578aa1bd677",
        voltageACDehumidifierZ3TowerTop: "ae1b735b-0912-42c4-b3b6-7f9d9acf8ce4",
        voltageBCDehumidifierZ3TowerTop: "1b122ba2-fcd0-4b5a-b7c4-56b7ebcfcde1",
        voltageABDehumidifierZ4TowerTop: "1d6210bb-bb7b-4f78-a03c-b304bb8abed3",
        voltageACDehumidifierZ4TowerTop: "ed4af5eb-0c19-47b1-9a10-b3fb3f9a12ec",
        voltageBCDehumidifierZ4TowerTop: "e3a9a802-f74b-42d1-ae16-196ac4f70b19",
        voltageABDehumidifierZ5TowerTop: "a6b3598f-4872-468d-992c-1ed54f55885e",
        voltageACDehumidifierZ5TowerTop: "7e19ea64-5cf2-4dbb-ad1d-bc084ac16d33",
        voltageBCDehumidifierZ5TowerTop: "3ae4a99f-46bf-44af-9fed-813e2b0141a0",
        voltageABDehumidifierZ6TowerTop: "39fab21e-eb48-497c-afb7-ae4103fd478c",
        voltageACDehumidifierZ6TowerTop: "f631bed1-335b-4a10-9cdc-f3cfb7a5787c",
        voltageBCDehumidifierZ6TowerTop: "21862bd8-b95f-4632-b603-10e9ef818394",
        voltageABDehumidifierZ7TowerTop: "b2796ccc-3a6f-4ad7-b997-87023b7c2f84",
        voltageACDehumidifierZ7TowerTop: "977100b7-c5c1-4b23-88f3-806f7c824bb2",
        voltageBCDehumidifierZ7TowerTop: "27fbd8c6-829e-4f16-a7ef-41fdc4711dba",
        voltageABDehumidifierZ8TowerTop: "f70c38ac-1aac-47f1-af5e-840a64631081",
        voltageACDehumidifierZ8TowerTop: "fd050899-dca7-4631-ba3a-4812c537a770",
        voltageBCDehumidifierZ8TowerTop: "9f154727-bca6-4e2c-a544-913fa601e7be",

        powerActiveDehumidifierRigidHingeJ1: "a7cbdda6-aeab-499a-a03c-bbe91de0ae3e",
        powerApparentDehumidifierRigidHingeJ1: "1767eec5-7af0-4084-94ac-5d41fbbf956a",
        powerReactiveDehumidifierRigidHingeJ1: "cb27eea2-72ee-4632-b2d9-7bbcc1e768ab",
        powerActiveDehumidifierRigidHingeJ2: "23736bad-5b89-4187-b4b0-ad8159d5adce",
        powerApparentDehumidifierRigidHingeJ2: "34a77da7-b83e-440f-9175-03b7e5cd129e",
        powerReactiveDehumidifierRigidHingeJ2: "dadedd53-6d0f-4e1a-af0e-fb4745742609",
        powerActiveDehumidifierRigidHingeJ3: "5b277c43-b46a-4cf0-92cc-4fc8e44ca573",
        powerApparentDehumidifierRigidHingeJ3: "1d9cc1de-0fa1-4015-b342-a73db593a487",
        powerReactiveDehumidifierRigidHingeJ3: "d588be81-acef-411d-9e12-63d19e557c66",
        powerActiveDehumidifierRigidHingeJ4: "6ea4ee03-48bc-47ce-a318-b91e6152fb77",
        powerApparentDehumidifierRigidHingeJ4: "f61624bc-ddf1-4018-8e8d-e4d3ba5f78a4",
        powerReactiveDehumidifierRigidHingeJ4: "53d3c01a-ca36-420c-8fd8-971f75846777",

        powerActiveDehumidifierZ3TowerMid: "648d2945-65a3-4b43-a9dd-f07dfe7210f4",
        powerApparentDehumidifierZ3TowerMid: "39baad67-5ec0-4159-b496-2dd95155bc23",
        powerReactiveDehumidifierZ3TowerMid: "ed62770e-37e8-4e8e-b120-27bc834a808a",
        powerActiveDehumidifierZ4TowerMid: "e6b10049-712d-46b3-b324-9fcf492350e1",
        powerApparentDehumidifierZ4TowerMid: "bd7757e2-ff6d-40fb-88a8-706c577cf111",
        powerReactiveDehumidifierZ4TowerMid: "63af2847-e2db-4be4-8e4a-0931cf0fec14",
        powerActiveDehumidifierZ5TowerMid: "95c26003-d0ad-4467-8308-93da9b981671",
        powerApparentDehumidifierZ5TowerMid: "d53d35fb-7814-42ae-8810-3009e49435d7",
        powerReactiveDehumidifierZ5TowerMid: "7e28ec88-fadd-4e3b-ab96-9fa1b2fd4c1d",
        powerActiveDehumidifierZ6TowerMid: "bebc1877-5b02-41bf-b32b-dfdd4d77c2ad",
        powerApparentDehumidifierZ6TowerMid: "03494f7d-146d-4f2a-9f7a-674024629716",
        powerReactiveDehumidifierZ6TowerMid: "54e67c09-f412-4657-9ab7-0aeb8b04f2fa",
        powerActiveDehumidifierZ7TowerMid: "52d65738-79ee-42b4-8512-e42a1d7ebf80",
        powerApparentDehumidifierZ7TowerMid: "15ad6157-895b-4508-834a-4a642b5d836d",
        powerReactiveDehumidifierZ7TowerMid: "7e19151e-cc62-4caa-979f-9a8d233a9f17",
        powerActiveDehumidifierZ8TowerMid: "ff9781e3-105b-483f-9ef0-c6c09eba1553",
        powerApparentDehumidifierZ8TowerMid: "4d280c6a-8fdb-4e49-ab7c-862e6e8387ff",
        powerReactiveDehumidifierZ8TowerMid: "99fcbdeb-0acc-4aad-9782-ff64f3d128d3",
        powerActiveDehumidifierZ3TowerTop: "8fe8f65b-2fbc-474b-b9f7-d70fd10f8964",
        powerApparentDehumidifierZ3TowerTop: "f0dd3506-0947-4685-8720-549fa19ed372",
        powerReactiveDehumidifierZ3TowerTop: "d1b87dff-41b2-4548-852d-a8967a4f7ac6",
        powerActiveDehumidifierZ4TowerTop: "7e719899-401b-4426-9092-41667f3a6d8e",
        powerApparentDehumidifierZ4TowerTop: "8e71e899-513e-4e09-8c6e-8a862302d3a4",
        powerReactiveDehumidifierZ4TowerTop: "1e573b32-0d7b-43bb-aaaa-ee5b66cbe343",
        powerActiveDehumidifierZ5TowerTop: "5072bda0-70b2-40a4-9888-45e0c396055b",
        powerApparentDehumidifierZ5TowerTop: "37b75c90-1fb7-4928-9cfa-e050a73dac92",
        powerReactiveDehumidifierZ5TowerTop: "96cab530-7f6f-4e20-8a6e-83fae870f0cf",
        powerActiveDehumidifierZ6TowerTop: "05e4efcf-f031-45da-bbee-1360e9fb8f91",
        powerApparentDehumidifierZ6TowerTop: "37b22d1f-2296-4fe9-bb5c-53556f0977fb",
        powerReactiveDehumidifierZ6TowerTop: "55af04e5-8355-4250-875b-0c74528e2689",
        powerActiveDehumidifierZ7TowerTop: "b0aaa4be-8f92-4651-bbcb-d35e6765c2e8",
        powerApparentDehumidifierZ7TowerTop: "bb92e5cf-1ed9-44f5-9ad5-71e8d82ff94d",
        powerReactiveDehumidifierZ7TowerTop: "17344a63-ec65-4104-8896-37ef1f5203ce",
        powerActiveDehumidifierZ8TowerTop: "06c55b87-602d-47bf-9829-8c3cf2883ddd",
        powerApparentDehumidifierZ8TowerTop: "55fc1924-b684-4245-9041-bc88a7fd13d9",
        powerReactiveDehumidifierZ8TowerTop: "4e481988-8325-47fe-a867-2b3b3ad0b994",

        energyActiveDehumidifierRigidHingeJ1: "524d647c-5e0b-43b0-a933-5af20d6ed78f",
        energyReactiveDehumidifierRigidHingeJ1: "4c074e8f-e458-4a61-87b2-09285ab3cf5d",
        energyActiveDehumidifierRigidHingeJ2: "cc388f98-7508-45d6-a301-3afb930ddcee",
        energyReactiveDehumidifierRigidHingeJ2: "a3c353b6-c016-42b5-a443-a34dcf0867ae",
        energyActiveDehumidifierRigidHingeJ3: "92d8cef8-a625-403c-9eeb-8d1b4872f23d",
        energyReactiveDehumidifierRigidHingeJ3: "3a8fb111-2919-4e80-9c4a-1f6b8197b01a",
        energyActiveDehumidifierRigidHingeJ4: "16f634cd-e096-4282-be16-feb61e416142",
        energyReactiveDehumidifierRigidHingeJ4: "7a7d8de6-12b5-4b9a-bd97-c6af386df14a",

        energyActiveDehumidifierZ3TowerMid: "3ec9456e-1df5-45ab-9f65-84b2fd41cbd4",
        energyReactiveDehumidifierZ3TowerMid: "523504b1-57bb-4410-8194-b70aa5e0c8b2",
        energyActiveDehumidifierZ4TowerMid: "0caeb433-3b38-47ca-a08e-7333291669a0",
        energyReactiveDehumidifierZ4TowerMid: "fc4c4dd4-f15d-4954-870c-705b712db35f",
        energyActiveDehumidifierZ5TowerMid: "1c39ef59-fec4-4f5d-92f9-1faa6d8a343a",
        energyReactiveDehumidifierZ5TowerMid: "881ff4b1-b6d1-46a1-85ec-5f84463c8150",
        energyActiveDehumidifierZ6TowerMid: "48281845-786f-4f13-85e7-132ccc98c01e",
        energyReactiveDehumidifierZ6TowerMid: "4bbd804e-3f69-400d-ac06-483c5f7395f7",
        energyActiveDehumidifierZ7TowerMid: "61556503-8fa9-4111-8558-e2dbf77bb8e3",
        energyReactiveDehumidifierZ7TowerMid: "ca63e910-2b78-4636-8d30-d89ba3e2f5af",
        energyActiveDehumidifierZ8TowerMid: "a72c0084-677c-421b-a3f7-2540a8f971a7",
        energyReactiveDehumidifierZ8TowerMid: "6d0c5e3e-888b-4805-8cf5-9da36e7ec422",
        energyActiveDehumidifierZ3TowerTop: "d9e7032d-bd57-4fe8-87a7-c3a1b073cb18",
        energyReactiveDehumidifierZ3TowerTop: "71bdb7cb-83d2-4f57-99dd-93eab16454b3",
        energyActiveDehumidifierZ4TowerTop: "c8142893-b81a-4168-970f-d1d9895f8f5c",
        energyReactiveDehumidifierZ4TowerTop: "e0aed836-08e1-4d65-bbcd-537f23cc3ba8",
        energyActiveDehumidifierZ5TowerTop: "92bf4ddc-f32c-4308-860f-b5874950a523",
        energyReactiveDehumidifierZ5TowerTop: "861dfd64-c0a8-4b3a-bce4-7938becbc02f",
        energyActiveDehumidifierZ6TowerTop: "607da295-da65-4a3a-a7cf-95e1a4dba962",
        energyReactiveDehumidifierZ6TowerTop: "aee53f1e-b7a2-40fe-a3a1-79f7b156ebf1",
        energyActiveDehumidifierZ7TowerTop: "c4bc3023-731f-4dcb-968d-9cf5ea0b300d",
        energyReactiveDehumidifierZ7TowerTop: "7033921a-a5dc-492b-8275-166e17eb1902",
        energyActiveDehumidifierZ8TowerTop: "b5971260-a969-4d37-a33e-cfbb2e0c594f",
        energyReactiveDehumidifierZ8TowerTop: "31427891-02b1-4975-b9f8-cd719eb3cd72",

        frequencyDehumidifierRigidHingeJ1: "dcaf3fdd-94c2-4bc2-acee-269a47fc0dd4",
        frequencyDehumidifierRigidHingeJ2: "e1825a9a-6ef4-4675-8f13-32efd3b407a1",
        frequencyDehumidifierRigidHingeJ3: "48947ce5-f197-43ac-a7ba-21a2f77923d5",
        frequencyDehumidifierRigidHingeJ4: "c36ea233-7d42-47bd-9638-a5f2e9fe2944",

        frequencyDehumidifierZ3TowerMid: "57c9de57-51d2-415a-bb2c-a95f2db1b3ce",
        frequencyDehumidifierZ4TowerMid: "e136805e-9a36-44bf-8b05-7625156c80a3",
        frequencyDehumidifierZ5TowerMid: "c5ac8d4c-d5e6-45b1-bcf8-a0ded3b3fc77",
        frequencyDehumidifierZ6TowerMid: "2a9eeff5-36cf-45c7-9c06-4461f0813aab",
        frequencyDehumidifierZ7TowerMid: "abf6fb52-c1d2-47a8-a34c-3bdd21f1136d",
        frequencyDehumidifierZ8TowerMid: "a9d2cfc1-50fe-4bd5-8ba2-af8726248c95",
        frequencyDehumidifierZ3TowerTop: "8edc2849-c674-41f7-8005-01e76a4c812a",
        frequencyDehumidifierZ4TowerTop: "05c6026e-eda2-4eae-8132-af20b55e2e24",
        frequencyDehumidifierZ5TowerTop: "e1ec7339-466e-4e21-a36d-8a07aad4af20",
        frequencyDehumidifierZ6TowerTop: "a517ce88-f5d3-40fa-99fe-d754b422b81c",
        frequencyDehumidifierZ7TowerTop: "c03dfc97-625d-40ee-b682-e190fc77fa39",
        frequencyDehumidifierZ8TowerTop: "f4a687cc-6620-4c69-906d-a887785da188",

        //running
        runningDehumidifierRigidHingeJ1: "20ff3f58-df5d-41f3-bedc-8f957104d4c9",
        runningDehumidifierRigidHingeJ2: "62eef0bc-f664-4489-af27-5258e1fc315a",
        runningDehumidifierRigidHingeJ3: "2cb60845-2de9-42b1-a92d-721ef419d5e9",
        runningDehumidifierRigidHingeJ4: "62ecec16-3bdb-4648-a51d-a23d9c6fa228",

        runningDehumidifierZ3TowerMid: "a682cc97-20a4-44ad-a7fb-028e1dc1bffc",
        runningDehumidifierZ4TowerMid: "2a51e1c2-7497-4879-bd54-de15473f03ca",
        runningDehumidifierZ5TowerMid: "3dc969d8-daf8-4245-8708-42749bda27d6",
        runningDehumidifierZ6TowerMid: "50302fdf-28eb-4349-812d-0115f60f0a9a",
        runningDehumidifierZ7TowerMid: "991e0c95-c4e5-4652-9a06-ab546e9c126e",
        runningDehumidifierZ8TowerMid: "5f645a41-5b88-42e8-963f-5cae56fa1f0f",
        runningDehumidifierZ3TowerTop: "1b5f35b9-c0fd-412a-8c36-a15253c3cc8d",
        runningDehumidifierZ4TowerTop: "d7caad97-22f9-4821-97d5-5863b9e0a1c5",
        runningDehumidifierZ5TowerTop: "e2539e56-f5e0-427d-93db-cc8816af03de",
        runningDehumidifierZ6TowerTop: "1d3e2c87-077c-4950-b273-638a7b24a749",
        runningDehumidifierZ7TowerTop: "27558f47-60b4-4a94-9740-b40ad9f5ba26",
        runningDehumidifierZ8TowerTop: "32c177fe-db1c-4aef-baee-4ab685e61493",

        //malfunction
        malfunctionDehumidifierZ3TowerMid: "b76e3d1b-17b3-48a1-b5bf-54bba5ed67c1",
        malfunctionDehumidifierZ3TowerTop: "aa67031c-00ab-4dbe-8783-6a2ab43e3744",
        malfunctionDehumidifierZ4TowerMid: "4f36f298-0536-413a-b97e-62866346085f",
        malfunctionDehumidifierZ4TowerTop: "2feedca5-679b-43d5-beb3-1919dee9c69d",
        malfunctionDehumidifierZ5TowerMid: "fe4f9046-7fa1-4b81-9089-bb73909e37b6",
        malfunctionDehumidifierZ5TowerTop: "77c09a14-e132-49d2-b652-0617b7dd4631",
        malfunctionDehumidifierZ6TowerMid: "915f58db-c862-47b7-9c83-ed319f86d3a0",
        malfunctionDehumidifierZ6TowerTop: "a9ca5c3e-9bab-437c-a423-c07dd4496909",
        malfunctionDehumidifierZ7TowerMid: "7a324484-b71e-46c5-bf8f-f34a1ad40c75",
        malfunctionDehumidifierZ7TowerTop: "60758cfc-d499-4fe7-897e-acca0d659fcc",
        malfunctionDehumidifierZ8TowerMid: "f2debb6a-181c-49f2-a942-8c3c9fa12595",
        malfunctionDehumidifierZ8TowerTop: "31d41712-dec8-4b4c-879d-547cd16750fb",

        malfunctionDehumidifierRigidHingeJ1: "510e0cd1-2bdd-4424-b6ae-050b9f1f4620",
        malfunctionDehumidifierRigidHingeJ2: "722d94bd-e059-46f1-8c4b-0e73552436a4",
        malfunctionDehumidifierRigidHingeJ3: "417c5e71-2153-4758-b066-5333e7f55412",
        malfunctionDehumidifierRigidHingeJ4: "56abfcdc-f086-450c-8d97-79098b16556c",
      },

      //humidity allowed max -> id
      allowedMaxNameIdDict: {},

      //humidity, temperature -> error
      dataNameErrorNameDict: {
        currentADehumidifierZ3TowerTop: "errorZ3TowerTop",
        currentADehumidifierZ3TowerMid: "errorZ3TowerMid",
        currentADehumidifierZ4TowerTop: "errorZ4TowerTop",
        currentADehumidifierZ4TowerMid: "errorZ4TowerMid",
        currentADehumidifierZ5TowerTop: "errorZ5TowerTop",
        currentADehumidifierZ5TowerMid: "errorZ5TowerMid",
        currentADehumidifierZ6TowerTop: "errorZ6TowerTop",
        currentADehumidifierZ6TowerMid: "errorZ6TowerMid",
        currentADehumidifierZ7TowerTop: "errorZ7TowerTop",
        currentADehumidifierZ7TowerMid: "errorZ7TowerMid",
        currentADehumidifierZ8TowerTop: "errorZ8TowerTop",
        currentADehumidifierZ8TowerMid: "errorZ8TowerMid",
        currentBDehumidifierZ3TowerTop: "errorZ3TowerTop",
        currentBDehumidifierZ3TowerMid: "errorZ3TowerMid",
        currentBDehumidifierZ4TowerTop: "errorZ4TowerTop",
        currentBDehumidifierZ4TowerMid: "errorZ4TowerMid",
        currentBDehumidifierZ5TowerTop: "errorZ5TowerTop",
        currentBDehumidifierZ5TowerMid: "errorZ5TowerMid",
        currentBDehumidifierZ6TowerTop: "errorZ6TowerTop",
        currentBDehumidifierZ6TowerMid: "errorZ6TowerMid",
        currentBDehumidifierZ7TowerTop: "errorZ7TowerTop",
        currentBDehumidifierZ7TowerMid: "errorZ7TowerMid",
        currentBDehumidifierZ8TowerTop: "errorZ8TowerTop",
        currentBDehumidifierZ8TowerMid: "errorZ8TowerMid",
        currentCDehumidifierZ3TowerTop: "errorZ3TowerTop",
        currentCDehumidifierZ3TowerMid: "errorZ3TowerMid",
        currentCDehumidifierZ4TowerTop: "errorZ4TowerTop",
        currentCDehumidifierZ4TowerMid: "errorZ4TowerMid",
        currentCDehumidifierZ5TowerTop: "errorZ5TowerTop",
        currentCDehumidifierZ5TowerMid: "errorZ5TowerMid",
        currentCDehumidifierZ6TowerTop: "errorZ6TowerTop",
        currentCDehumidifierZ6TowerMid: "errorZ6TowerMid",
        currentCDehumidifierZ7TowerTop: "errorZ7TowerTop",
        currentCDehumidifierZ7TowerMid: "errorZ7TowerMid",
        currentCDehumidifierZ8TowerTop: "errorZ8TowerTop",
        currentCDehumidifierZ8TowerMid: "errorZ8TowerMid",

        currentADehumidifierRigidHingeJ1: "errorRigidHingeJ3RJ1",
        currentADehumidifierRigidHingeJ2: "errorRigidHingeJ3RJ2",
        currentADehumidifierRigidHingeJ3: "errorRigidHingeJ3LJ3",
        currentADehumidifierRigidHingeJ4: "errorRigidHingeJ3LJ4",
        currentBDehumidifierRigidHingeJ1: "errorRigidHingeJ3RJ1",
        currentBDehumidifierRigidHingeJ2: "errorRigidHingeJ3RJ2",
        currentBDehumidifierRigidHingeJ3: "errorRigidHingeJ3LJ3",
        currentBDehumidifierRigidHingeJ4: "errorRigidHingeJ3LJ4",
        currentCDehumidifierRigidHingeJ1: "errorRigidHingeJ3RJ1",
        currentCDehumidifierRigidHingeJ2: "errorRigidHingeJ3RJ2",
        currentCDehumidifierRigidHingeJ3: "errorRigidHingeJ3LJ3",
        currentCDehumidifierRigidHingeJ4: "errorRigidHingeJ3LJ4",

        voltageABDehumidifierZ3TowerTop: "errorZ3TowerTop",
        voltageABDehumidifierZ3TowerMid: "errorZ3TowerMid",
        voltageABDehumidifierZ4TowerTop: "errorZ4TowerTop",
        voltageABDehumidifierZ4TowerMid: "errorZ4TowerMid",
        voltageABDehumidifierZ5TowerTop: "errorZ5TowerTop",
        voltageABDehumidifierZ5TowerMid: "errorZ5TowerMid",
        voltageABDehumidifierZ6TowerTop: "errorZ6TowerTop",
        voltageABDehumidifierZ6TowerMid: "errorZ6TowerMid",
        voltageABDehumidifierZ7TowerTop: "errorZ7TowerTop",
        voltageABDehumidifierZ7TowerMid: "errorZ7TowerMid",
        voltageABDehumidifierZ8TowerTop: "errorZ8TowerTop",
        voltageABDehumidifierZ8TowerMid: "errorZ8TowerMid",
        voltageBCDehumidifierZ3TowerTop: "errorZ3TowerTop",
        voltageBCDehumidifierZ3TowerMid: "errorZ3TowerMid",
        voltageBCDehumidifierZ4TowerTop: "errorZ4TowerTop",
        voltageBCDehumidifierZ4TowerMid: "errorZ4TowerMid",
        voltageBCDehumidifierZ5TowerTop: "errorZ5TowerTop",
        voltageBCDehumidifierZ5TowerMid: "errorZ5TowerMid",
        voltageBCDehumidifierZ6TowerTop: "errorZ6TowerTop",
        voltageBCDehumidifierZ6TowerMid: "errorZ6TowerMid",
        voltageBCDehumidifierZ7TowerTop: "errorZ7TowerTop",
        voltageBCDehumidifierZ7TowerMid: "errorZ7TowerMid",
        voltageBCDehumidifierZ8TowerTop: "errorZ8TowerTop",
        voltageBCDehumidifierZ8TowerMid: "errorZ8TowerMid",
        voltageACDehumidifierZ3TowerTop: "errorZ3TowerTop",
        voltageACDehumidifierZ3TowerMid: "errorZ3TowerMid",
        voltageACDehumidifierZ4TowerTop: "errorZ4TowerTop",
        voltageACDehumidifierZ4TowerMid: "errorZ4TowerMid",
        voltageACDehumidifierZ5TowerTop: "errorZ5TowerTop",
        voltageACDehumidifierZ5TowerMid: "errorZ5TowerMid",
        voltageACDehumidifierZ6TowerTop: "errorZ6TowerTop",
        voltageACDehumidifierZ6TowerMid: "errorZ6TowerMid",
        voltageACDehumidifierZ7TowerTop: "errorZ7TowerTop",
        voltageACDehumidifierZ7TowerMid: "errorZ7TowerMid",
        voltageACDehumidifierZ8TowerTop: "errorZ8TowerTop",
        voltageACDehumidifierZ8TowerMid: "errorZ8TowerMid",

        voltageABDehumidifierRigidHingeJ1: "errorRigidHingeJ3RJ1",
        voltageABDehumidifierRigidHingeJ2: "errorRigidHingeJ3RJ2",
        voltageABDehumidifierRigidHingeJ3: "errorRigidHingeJ3LJ3",
        voltageABDehumidifierRigidHingeJ4: "errorRigidHingeJ3LJ4",
        voltageBCDehumidifierRigidHingeJ1: "errorRigidHingeJ3RJ1",
        voltageBCDehumidifierRigidHingeJ2: "errorRigidHingeJ3RJ2",
        voltageBCDehumidifierRigidHingeJ3: "errorRigidHingeJ3LJ3",
        voltageBCDehumidifierRigidHingeJ4: "errorRigidHingeJ3LJ4",
        voltageACDehumidifierRigidHingeJ1: "errorRigidHingeJ3RJ1",
        voltageACDehumidifierRigidHingeJ2: "errorRigidHingeJ3RJ2",
        voltageACDehumidifierRigidHingeJ3: "errorRigidHingeJ3LJ3",
        voltageACDehumidifierRigidHingeJ4: "errorRigidHingeJ3LJ4",

        powerActiveDehumidifierZ3TowerTop: "errorZ3TowerTop",
        powerActiveDehumidifierZ3TowerMid: "errorZ3TowerMid",
        powerActiveDehumidifierZ4TowerTop: "errorZ4TowerTop",
        powerActiveDehumidifierZ4TowerMid: "errorZ4TowerMid",
        powerActiveDehumidifierZ5TowerTop: "errorZ5TowerTop",
        powerActiveDehumidifierZ5TowerMid: "errorZ5TowerMid",
        powerActiveDehumidifierZ6TowerTop: "errorZ6TowerTop",
        powerActiveDehumidifierZ6TowerMid: "errorZ6TowerMid",
        powerActiveDehumidifierZ7TowerTop: "errorZ7TowerTop",
        powerActiveDehumidifierZ7TowerMid: "errorZ7TowerMid",
        powerActiveDehumidifierZ8TowerTop: "errorZ8TowerTop",
        powerActiveDehumidifierZ8TowerMid: "errorZ8TowerMid",
        powerReactiveDehumidifierZ3TowerTop: "errorZ3TowerTop",
        powerReactiveDehumidifierZ3TowerMid: "errorZ3TowerMid",
        powerReactiveDehumidifierZ4TowerTop: "errorZ4TowerTop",
        powerReactiveDehumidifierZ4TowerMid: "errorZ4TowerMid",
        powerReactiveDehumidifierZ5TowerTop: "errorZ5TowerTop",
        powerReactiveDehumidifierZ5TowerMid: "errorZ5TowerMid",
        powerReactiveDehumidifierZ6TowerTop: "errorZ6TowerTop",
        powerReactiveDehumidifierZ6TowerMid: "errorZ6TowerMid",
        powerReactiveDehumidifierZ7TowerTop: "errorZ7TowerTop",
        powerReactiveDehumidifierZ7TowerMid: "errorZ7TowerMid",
        powerReactiveDehumidifierZ8TowerTop: "errorZ8TowerTop",
        powerReactiveDehumidifierZ8TowerMid: "errorZ8TowerMid",
        powerApparentDehumidifierZ3TowerTop: "errorZ3TowerTop",
        powerApparentDehumidifierZ3TowerMid: "errorZ3TowerMid",
        powerApparentDehumidifierZ4TowerTop: "errorZ4TowerTop",
        powerApparentDehumidifierZ4TowerMid: "errorZ4TowerMid",
        powerApparentDehumidifierZ5TowerTop: "errorZ5TowerTop",
        powerApparentDehumidifierZ5TowerMid: "errorZ5TowerMid",
        powerApparentDehumidifierZ6TowerTop: "errorZ6TowerTop",
        powerApparentDehumidifierZ6TowerMid: "errorZ6TowerMid",
        powerApparentDehumidifierZ7TowerTop: "errorZ7TowerTop",
        powerApparentDehumidifierZ7TowerMid: "errorZ7TowerMid",
        powerApparentDehumidifierZ8TowerTop: "errorZ8TowerTop",
        powerApparentDehumidifierZ8TowerMid: "errorZ8TowerMid",

        powerActiveDehumidifierRigidHingeJ1: "errorRigidHingeJ3RJ1",
        powerActiveDehumidifierRigidHingeJ2: "errorRigidHingeJ3RJ2",
        powerActiveDehumidifierRigidHingeJ3: "errorRigidHingeJ3LJ3",
        powerActiveDehumidifierRigidHingeJ4: "errorRigidHingeJ3LJ4",
        powerReactiveDehumidifierRigidHingeJ1: "errorRigidHingeJ3RJ1",
        powerReactiveDehumidifierRigidHingeJ2: "errorRigidHingeJ3RJ2",
        powerReactiveDehumidifierRigidHingeJ3: "errorRigidHingeJ3LJ3",
        powerReactiveDehumidifierRigidHingeJ4: "errorRigidHingeJ3LJ4",
        powerApparentDehumidifierRigidHingeJ1: "errorRigidHingeJ3RJ1",
        powerApparentDehumidifierRigidHingeJ2: "errorRigidHingeJ3RJ2",
        powerApparentDehumidifierRigidHingeJ3: "errorRigidHingeJ3LJ3",
        powerApparentDehumidifierRigidHingeJ4: "errorRigidHingeJ3LJ4",

        energyActiveDehumidifierZ3TowerTop: "errorZ3TowerTop",
        energyActiveDehumidifierZ3TowerMid: "errorZ3TowerMid",
        energyActiveDehumidifierZ4TowerTop: "errorZ4TowerTop",
        energyActiveDehumidifierZ4TowerMid: "errorZ4TowerMid",
        energyActiveDehumidifierZ5TowerTop: "errorZ5TowerTop",
        energyActiveDehumidifierZ5TowerMid: "errorZ5TowerMid",
        energyActiveDehumidifierZ6TowerTop: "errorZ6TowerTop",
        energyActiveDehumidifierZ6TowerMid: "errorZ6TowerMid",
        energyActiveDehumidifierZ7TowerTop: "errorZ7TowerTop",
        energyActiveDehumidifierZ7TowerMid: "errorZ7TowerMid",
        energyActiveDehumidifierZ8TowerTop: "errorZ8TowerTop",
        energyActiveDehumidifierZ8TowerMid: "errorZ8TowerMid",
        energyReactiveDehumidifierZ3TowerTop: "errorZ3TowerTop",
        energyReactiveDehumidifierZ3TowerMid: "errorZ3TowerMid",
        energyReactiveDehumidifierZ4TowerTop: "errorZ4TowerTop",
        energyReactiveDehumidifierZ4TowerMid: "errorZ4TowerMid",
        energyReactiveDehumidifierZ5TowerTop: "errorZ5TowerTop",
        energyReactiveDehumidifierZ5TowerMid: "errorZ5TowerMid",
        energyReactiveDehumidifierZ6TowerTop: "errorZ6TowerTop",
        energyReactiveDehumidifierZ6TowerMid: "errorZ6TowerMid",
        energyReactiveDehumidifierZ7TowerTop: "errorZ7TowerTop",
        energyReactiveDehumidifierZ7TowerMid: "errorZ7TowerMid",
        energyReactiveDehumidifierZ8TowerTop: "errorZ8TowerTop",
        energyReactiveDehumidifierZ8TowerMid: "errorZ8TowerMid",

        energyActiveDehumidifierRigidHingeJ1: "errorRigidHingeJ3RJ1",
        energyActiveDehumidifierRigidHingeJ2: "errorRigidHingeJ3RJ2",
        energyActiveDehumidifierRigidHingeJ3: "errorRigidHingeJ3LJ3",
        energyActiveDehumidifierRigidHingeJ4: "errorRigidHingeJ3LJ4",
        energyReactiveDehumidifierRigidHingeJ1: "errorRigidHingeJ3RJ1",
        energyReactiveDehumidifierRigidHingeJ2: "errorRigidHingeJ3RJ2",
        energyReactiveDehumidifierRigidHingeJ3: "errorRigidHingeJ3LJ3",
        energyReactiveDehumidifierRigidHingeJ4: "errorRigidHingeJ3LJ4",

        frequencyDehumidifierZ3TowerTop: "errorZ3TowerTop",
        frequencyDehumidifierZ3TowerMid: "errorZ3TowerMid",
        frequencyDehumidifierZ4TowerTop: "errorZ4TowerTop",
        frequencyDehumidifierZ4TowerMid: "errorZ4TowerMid",
        frequencyDehumidifierZ5TowerTop: "errorZ5TowerTop",
        frequencyDehumidifierZ5TowerMid: "errorZ5TowerMid",
        frequencyDehumidifierZ6TowerTop: "errorZ6TowerTop",
        frequencyDehumidifierZ6TowerMid: "errorZ6TowerMid",
        frequencyDehumidifierZ7TowerTop: "errorZ7TowerTop",
        frequencyDehumidifierZ7TowerMid: "errorZ7TowerMid",
        frequencyDehumidifierZ8TowerTop: "errorZ8TowerTop",
        frequencyDehumidifierZ8TowerMid: "errorZ8TowerMid",

        frequencyDehumidifierRigidHingeJ1: "errorRigidHingeJ3RJ1",
        frequencyDehumidifierRigidHingeJ2: "errorRigidHingeJ3RJ2",
        frequencyDehumidifierRigidHingeJ3: "errorRigidHingeJ3LJ3",
        frequencyDehumidifierRigidHingeJ4: "errorRigidHingeJ3LJ4",
      },

      //malfunction -> error
      malfunctionDataNameErrorNameDict: {
        malfunctionDehumidifierZ3TowerTop: "errorZ3TowerTop",
        malfunctionDehumidifierZ3TowerMid: "errorZ3TowerMid",
        malfunctionDehumidifierZ4TowerTop: "errorZ4TowerTop",
        malfunctionDehumidifierZ4TowerMid: "errorZ4TowerMid",
        malfunctionDehumidifierZ5TowerTop: "errorZ5TowerTop",
        malfunctionDehumidifierZ5TowerMid: "errorZ5TowerMid",
        malfunctionDehumidifierZ6TowerTop: "errorZ6TowerTop",
        malfunctionDehumidifierZ6TowerMid: "errorZ6TowerMid",
        malfunctionDehumidifierZ7TowerTop: "errorZ7TowerTop",
        malfunctionDehumidifierZ7TowerMid: "errorZ7TowerMid",
        malfunctionDehumidifierZ8TowerTop: "errorZ8TowerTop",
        malfunctionDehumidifierZ8TowerMid: "errorZ8TowerMid",

        malfunctionDehumidifierRigidHingeJ1: "errorRigidHingeJ3RJ1",
        malfunctionDehumidifierRigidHingeJ2: "errorRigidHingeJ3RJ2",
        malfunctionDehumidifierRigidHingeJ3: "errorRigidHingeJ3LJ3",
        malfunctionDehumidifierRigidHingeJ4: "errorRigidHingeJ3LJ4",
      },

      //humidity -> humidity tooltip error
      dataNameTooltipErrorNameDict: {},

      //running -> running class
      dataNameRunningClassNameDict: {
        runningDehumidifierZ3TowerTop: "runningClassZ3TowerTop",
        runningDehumidifierZ3TowerMid: "runningClassZ3TowerMid",
        runningDehumidifierZ4TowerTop: "runningClassZ4TowerTop",
        runningDehumidifierZ4TowerMid: "runningClassZ4TowerMid",
        runningDehumidifierZ5TowerTop: "runningClassZ5TowerTop",
        runningDehumidifierZ5TowerMid: "runningClassZ5TowerMid",
        runningDehumidifierZ6TowerTop: "runningClassZ6TowerTop",
        runningDehumidifierZ6TowerMid: "runningClassZ6TowerMid",
        runningDehumidifierZ7TowerTop: "runningClassZ7TowerTop",
        runningDehumidifierZ7TowerMid: "runningClassZ7TowerMid",
        runningDehumidifierZ8TowerTop: "runningClassZ8TowerTop",
        runningDehumidifierZ8TowerMid: "runningClassZ8TowerMid",

        runningDehumidifierRigidHingeJ1: "runningClassRigidHingeJ3RJ1",
        runningDehumidifierRigidHingeJ2: "runningClassRigidHingeJ3RJ2",
        runningDehumidifierRigidHingeJ3: "runningClassRigidHingeJ3LJ3",
        runningDehumidifierRigidHingeJ4: "runningClassRigidHingeJ3LJ4",
      },

      //station id list
      stationIdList: [
        "c33683d9-d3a2-4773-9abf-b48880ff2327",
        "bc6a1ac2-0b69-4430-84d5-90eb2dd769b2",
        "e0343595-56b1-4b05-a77e-1752830ea6b1",
        "690856ee-aeff-4f53-948d-273585993c44",
        "199106fc-bec1-4174-834f-4d583d5185fd",
        "166b7b7f-a992-45e0-bde6-e04689630d2f",
        "f73c982e-a4fa-4973-8818-5c9b672d88fd",
        "9b38b422-ff93-48db-981a-1017e33d8f59",
        "a880af4a-c81d-4f8f-9212-39a6fd38cdc8",
        "60fc2036-f725-48bf-92ea-53508e15283a",
        "91d4c6b8-54ab-4f73-94f9-dabfad7adb25",
        "59fb6315-98e8-4491-8aa9-1546fb24fe36",
        "23861f72-4dd6-4ab8-9015-e00ab99f0ad7",
        "033372f1-e484-414a-8ded-c753e7769c99",
        "514efa00-fcb6-4fae-8059-fa4355e721eb",
        "40d46dbd-d285-4fee-9cc9-6552abdd8ea0",
      ],

      stationNameStationIdDict: {
        "stationT2": "c33683d9-d3a2-4773-9abf-b48880ff2327",
        "stationT1": "bc6a1ac2-0b69-4430-84d5-90eb2dd769b2",
        "stationT9": "e0343595-56b1-4b05-a77e-1752830ea6b1",
        "stationT11": "690856ee-aeff-4f53-948d-273585993c44",
        "stationT3": "199106fc-bec1-4174-834f-4d583d5185fd",
        "stationT6": "166b7b7f-a992-45e0-bde6-e04689630d2f",
        "stationT7": "f73c982e-a4fa-4973-8818-5c9b672d88fd",
        "stationT4": "9b38b422-ff93-48db-981a-1017e33d8f59",
        "stationT10": "a880af4a-c81d-4f8f-9212-39a6fd38cdc8",
        "stationT5": "60fc2036-f725-48bf-92ea-53508e15283a",
        "stationT8": "91d4c6b8-54ab-4f73-94f9-dabfad7adb25",
        "stationT12": "40d46dbd-d285-4fee-9cc9-6552abdd8ea0",
        "stationJ3": "59fb6315-98e8-4491-8aa9-1546fb24fe36",
        "stationJ1": "23861f72-4dd6-4ab8-9015-e00ab99f0ad7",
        "stationJ2": "033372f1-e484-414a-8ded-c753e7769c99",
        "stationJ4": "514efa00-fcb6-4fae-8059-fa4355e721eb",
      },

      stationNameLoadingDict: {
        "stationT2": false,
        "stationT1": false,
        "stationT9": false,
        "stationT11": false,
        "stationT3": false,
        "stationT6": false,
        "stationT7": false,
        "stationT4": false,
        "stationT10": false,
        "stationT5": false,
        "stationT8": false,
        "stationT12": false,
        "stationJ3": false,
        "stationJ1": false,
        "stationJ2": false,
        "stationJ4": false,
      },
    };
  },
  filters: {
    toFixed(val) {
      if (val === 0) return "0.0";
      if (!Number(val)) return "--";
      return Number(val).toFixed(1);
    },
  },
  mounted() {
    this.getAllowedMax();
    this.getData();
    this.timer = setInterval(() => {
      this.getData();
    }, this.REFRESH_SECOND);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    refreshData() {
      this.loading = true;
      this.getData();
    },
    getData() {
      this.resetError();
      this.loading = true;
      // let stationRequestList = [];
      // this.stationIdList.forEach((stationId) => {
      //   stationRequestList.push(this.$http.get(`/deviceData/Station?stationId=${stationId}`));
      // });

      // this.$http.all(stationRequestList).then(
      //   this.$http.spread((...resList) => {
      //     resList.forEach((res) => {
      //       this.setDataAndError(res.data);
      //       this.loading = false;
      //     });
      //   })
      // );

      for (let stationName in this.stationNameLoadingDict) {
        this.stationNameLoadingDict[stationName] = true;
      }

      this.$nextTick(() => {
        for (let stationName in this.stationNameStationIdDict) {
          this.getDataForStation(stationName);
        }

        setTimeout(() => {
          this.loading = false;
        }, 500);

      })


    },
    getDataForStation(stationName) {
      let stationId = this.stationNameStationIdDict[stationName];
      if (!stationId) {
        return;
      }

      this.stationNameLoadingDict[stationName] = true;
      this.$http.get('/deviceData/Station?stationId=' + stationId).then((res) => {
        this.setDataAndError(res.data);
        this.stationNameLoadingDict[stationName] = false;
      })
    },
    setDataAndError(stationData) {
      //device id not set (device id = 'GUID') = no data
      stationData["GUID"] = {
        dataId: null,
        deviceId: "GUID",
        value: null,
        createdDate: "0001-01-01T00:00:00",
        dataDate: "0001-01-01T00:00:00",
        dataType: "VALUE",
        errorLevel: "Warning",
      };

      for (let dataName in this.dataNameIdDict) {
        const dataId = this.dataNameIdDict[dataName];
        if (stationData[dataId] !== undefined) {
          this[dataName] = stationData[dataId].value;

          // //set value for running sign
          // if (this.dataNameRunningTooltipNameDict[dataName] !== undefined && this.dataNameRunningClassNameDict[dataName] != undefined) {
          //   let runningData = stationData[dataId];
          //   if (runningData.value === 1) {
          //     this[this.dataNameRunningTooltipNameDict[dataName]] = "运行";
          //     this[this.dataNameRunningClassNameDict[dataName]] = "running";
          //   } else if (runningData.errorLevel !== "Warning") {
          //     //empty data value also === 0
          //     this[this.dataNameRunningTooltipNameDict[dataName]] = "停止";
          //     this[this.dataNameRunningClassNameDict[dataName]] = "stopped";
          //   }
          // }

          //set value for running sign
          if (this.dataNameRunningClassNameDict[dataName] != undefined) {
            let runningData = stationData[dataId];
            if (runningData.value === 1) {
              this[this.dataNameRunningClassNameDict[dataName]] = "running";
            } else if (runningData.errorLevel !== "Warning") {
              //empty data value also === 0
              this[this.dataNameRunningClassNameDict[dataName]] = "stopped";
            }
          }

          if (this.dataNameErrorNameDict[dataName] !== undefined) {
            const errorName = this.dataNameErrorNameDict[dataName];
            this[errorName] = this.getErrorLevelFromMultipleDevice(this[errorName], stationData[dataId].errorLevel);
          }

          if (this.dataNameTooltipErrorNameDict[dataName] !== undefined) {
            const errorName = this.dataNameTooltipErrorNameDict[dataName];
            this[errorName] = stationData[dataId].errorLevel;
          }

          if (this.malfunctionDataNameErrorNameDict[dataName] !== undefined) {
            const errorName = this.malfunctionDataNameErrorNameDict[dataName];
            if (this[errorName] === "" && stationData[dataId].value && stationData[dataId].value > 0) {
              this[errorName] = "Error";
            }
          }
        }
      }
    },
    getAllowedMax() {
      let stationMetaRequestList = [];
      this.stationIdList.forEach((stationId) => {
        stationMetaRequestList.push(this.$http.get(`/bridge/StationInfo?stationId=${stationId}`));
      });

      this.$http.all(stationMetaRequestList).then(
        this.$http.spread((...resList) => {
          resList.forEach((res) => {
            this.setAllowedMax(res.data);
          });
        })
      );
    },
    setAllowedMax(stationData) {
      let deviceIdDevicedict = {};
      if (stationData.deviceList) {
        stationData.deviceList.forEach((item) => {
          deviceIdDevicedict[item.deviceId] = item;
        });
      }

      for (let allowedMaxName in this.allowedMaxNameIdDict) {
        const dataId = this.allowedMaxNameIdDict[allowedMaxName];
        if (deviceIdDevicedict[dataId] !== undefined) {
          let device = deviceIdDevicedict[dataId];
          this[allowedMaxName] = device.allowedMax;
        }
      }
    },
    getErrorLevelFromMultipleDevice(newErrorLevel, currentErrorLevel) {
      if (currentErrorLevel === "Error") {
        return "Error";
      } else if (currentErrorLevel === "Warning") {
        if (newErrorLevel === "Error") {
          return "Error";
        } else {
          return "Warning";
        }
      } else {
        return newErrorLevel;
      }
    },
    resetError() {
      for (let dataName in this.dataNameIdDict) {
        if (this.dataNameErrorNameDict[dataName] !== undefined) {
          const errorName = this.dataNameErrorNameDict[dataName];
          this[errorName] = "";
        }

        if (this.dataNameTooltipErrorNameDict[dataName] !== undefined) {
          const errorName = this.dataNameTooltipErrorNameDict[dataName];
          this[errorName] = "";
        }
      }
    },
    assembleTooltip_sensor(name, errorLevel, allowedMax) {
      let result = "";
      if (name) {
        result += name + ": ";
      }

      if (errorLevel.toLowerCase() === "normal") {
        result += "湿度正常";
      } else if (errorLevel.toLowerCase() === "warning") {
        result += "数据中断";
      } else if (errorLevel.toLowerCase() === "error") {
        result += "湿度超限";
      }

      if (
        (errorLevel.toLowerCase() === "normal" || errorLevel.toLowerCase() === "error") &&
        allowedMax !== undefined &&
        allowedMax !== null &&
        !isNaN(parseInt(allowedMax))
      ) {
        if (allowedMax === 0) {
          result += "(无限制)";
        } else {
          result += "(<" + allowedMax + "%RH)";
        }
      }

      return result;
    },
    assembleTooltip_dehumidifier(name, errorLevel, allowedMax, runningFlag, errorFlag) {
      let result = "";
      if (name) {
        result += name + ": ";
      }

      if (errorLevel.toLowerCase() === "normal") {
        result += "湿度正常";
      } else if (errorLevel.toLowerCase() === "warning") {
        result += "数据中断";
      } else if (errorLevel.toLowerCase() === "error") {
        result += "湿度超限";
      }

      if ((errorLevel.toLowerCase() === "normal" || errorLevel.toLowerCase() === "error") && allowedMax && !isNaN(parseInt(allowedMax))) {
        result += "(<" + allowedMax + "%RH)";
      }

      if (errorLevel === "" && allowedMax === "") {
        //no humidity dehumidfiier
        if (runningFlag === "--" || runningFlag === null || runningFlag === undefined || isNaN(Number(runningFlag))) {
          result += "数据中断";
        } else if (runningFlag > 0) {
          result += "除湿机运行";
        } else if (runningFlag === 0) {
          result += "除湿机停止";
        }

        if (errorFlag === "--" || errorFlag === null || errorFlag === undefined || isNaN(Number(errorFlag))) {
          if (result.indexOf("数据中断") < 0) {
            result += ", 数据中断";
          }
        } else if (errorFlag > 0) {
          result += ", 故障报警";
        }
      } else {
        //normal dehumidifer (with humidity)
        if (errorLevel.toLowerCase() !== "warning") {
          if (runningFlag > 0) {
            result += ", 除湿机运行";
          } else if (runningFlag === 0) {
            result += ", 除湿机停止";
          }
        }

        if (errorFlag > 0) {
          result += ", 故障报警";
        }
      }

      return result;
    },
    assembleTooltip_simpleKeyValue(name, value, unit) {
      let result = "";
      if (name) {
        result += name + "\u00A0\u00A0\u00A0\u00A0";
      }

      if (value === "--" || value === null || value === undefined || isNaN(Number(value))) {
        result += "数据中断";
      } else {
        result += Number(value).toFixed(1);
        if (unit) {
          result += unit;
        }
      }

      return result;
    },

    assembleTooltip_groupKeyValue(name, keyList, valueList, unitList) {
      let result = "";
      if (name) {
        result += name + "\u00A0\u00A0\u00A0\u00A0";
      }

      for (let i = 0; i < keyList.length; i++) {
        let key = keyList[i];
        let value = valueList[i];
        let unit = unitList[i];

        if (i !== 0) {
          result += " ";
        }
        result += key + ": ";

        if (value === "--" || value === null || value === undefined || isNaN(Number(value))) {
          result += "数据中断";
        } else {
          result += Number(value).toFixed(1);
          if (unit) {
            result += unit;
          }
        }
      }

      return result;
    },
    // hrefToScenario(id) {
    //   if (!id || id === "") {
    //     return;
    //   }

    //   this.$router.push("/" + this.routerPrefix + "/dataHistory?bridgeId=" + this.bridgeId + "&scenarioId=" + id);
    // },
  },
};
</script>

<style lang="scss" scoped>
@keyframes breathee-warning {
  0% {
    border-color: rgba(255, 255, 0, 0.3);
  }

  100% {
    border-color: #ffff00;
    // background: rgba(255, 255, 255, 0.7);
  }
}

@keyframes breathee-error {
  0% {
    border-color: rgba(255, 0, 0, 0.3);
  }

  100% {
    border-color: #ff0000;
    // background: rgba(255, 255, 255, 0.7);
  }
}

.tooltip-slot {
  line-height: 1.4;
}

.gas-clamp {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  height: calc(100% - 20px) !important;
  // min-height: 630px !important;

  .main-cable {
    width: 100%;
    height: 48%;
    padding: 0;
    display: flex;
    justify-content: flex-start;
    align-items: stretch;
    min-height: 370px;

    .cable-title {
      width: 50px;
      text-align: center;
      display: flex;
      background-color: #fff;
      justify-content: center;
      align-items: center;

      h2 {
        padding: 0 10px;
        font-weight: bold;
        font-size: 32px;
        line-height: 35px;
        color: #515151;
      }
    }

    .cable-main {
      position: relative;
      min-width: 1200px;
      width: calc(100% - 50px);
      background: linear-gradient(#ceeaf0, #e9f1ef);
      display: flex;
      justify-content: center;
      align-items: center;

      .legend {
        position: absolute;
        left: 75px;
        top: 50px;

        div {
          padding-left: 30px;
          height: 20px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;

          &:after {
            position: absolute;
            left: 0;
            top: 0;
            content: " ";
            overflow: hidden;
            display: block;
            height: 20px;
            width: 20px;
            border-radius: 10px;
          }
        }

        .sensor1:after {
          background: #c7798b;
        }

        .sensor2:after {
          background: #3376c7;
        }
      }

      .legend-right {
        position: absolute;
        right: 70px;
        top: 50px;

        div {
          padding-left: 30px;
          height: 20px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;

          &:after {
            position: absolute;
            left: 0;
            top: 0;
            content: " ";
            overflow: hidden;
            display: block;
            height: 20px;
            width: 20px;
            border-radius: 10px;
          }
        }

        .default:after {
          background: #ffff00;
        }

        .running:after {
          background: #67dd34;
        }

        .stopped:after {
          background: #a0a0a0;
        }
      }

      .legend-station {
        position: absolute;
        left: 73px;
        top: 108px;

        i {
          font-size: 24px;
          color: #ed6a5a;
        }

        span {
          padding-left: 8px;
          bottom: 3px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;
        }
      }

      .dir {
        position: absolute;
        top: 50px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        color: #2a387a;

        i {
          font-size: 30px;
        }

        .dir-text {
          font-size: 20px;
        }
      }

      .left-dir {
        left: 185px;
      }

      .right-dir {
        flex-direction: row-reverse;
        right: 185px;
      }

      .cable-img {
        position: relative;
        z-index: 0;
        width: 1200px;
        height: 300px;
        background-position: 50%;
        background-repeat: no-repeat;
        background-size: contain;
        background-image: url("../../assets/image/jiashao/bridgeLine.png");
        background-position-y: 100%;

        &.image-reversed {
          background-image: url("../../assets/image/jiashao/bridgeLineReversed.png");
        }

        .station-block {
          position: absolute;
          color: #ed6a5a;
          font-size: 24px;
          text-decoration: none;
        }

        .tower-name {
          border-radius: 50%;
          color: #344084;
          font-weight: bold;
          display: flex;
          justify-content: center;
          align-items: center;
          border: 3px solid;
          width: 24px;
          height: 24px;
          padding-left: 1px;

          &.tower-name-z3 {
            position: absolute;
            top: 274px;
            left: 264px;
          }

          &.tower-name-z4 {
            position: absolute;
            top: 274px;
            left: 620px;
          }

          &.tower-name-z5 {
            position: absolute;
            top: 274px;
            left: 975px;
          }

          &.tower-name-z6 {
            position: absolute;
            top: 274px;
            left: 184px;
          }

          &.tower-name-z7 {
            position: absolute;
            top: 274px;
            left: 540px;
          }

          &.tower-name-z8 {
            position: absolute;
            top: 274px;
            left: 895px;
          }
        }

        .stati {
          position: absolute;

          &:before,
          &:after {
            position: absolute;
            display: block;
            content: "";
            height: 2px;
            background: #ed6a5a;
          }

          &:before {
            width: 50px;
          }

          &:after {
            width: 15px;
          }

          .state-info {
            font-size: 14px;
            line-height: 17px;
            color: #515151;
            text-align: right;
            min-width: 75px;
            transform: translateY(-50%);
            position: absolute;
            text-decoration: none;
            border-radius: 10px;
            box-sizing: border-box;
            padding: 6px 8px 6px 6px;
            border: 2px solid transparent;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
            background-color: rgba(246, 250, 255, 0.9);

            &:before {
              background-color: #ed6a5a;
            }

            &>p {
              margin: 0;
              white-space: nowrap;
              white-space: nowrap;
              display: flex;
              justify-content: space-between;
              align-items: baseline;

              &:first-child {
                font-size: 13px;
              }
            }

            &.right-pos:before {
              right: 0;
              transform: translate(50%, -50%);
            }

            &.left-pos:before {
              left: -8px;
              transform: translate(50%, -50%);
            }

            &.bottom-pos:before {
              left: 50%;
              top: 96%;
              transform: translate(0%, 0%);
            }

            &.bottom-left-pos:before {
              left: 32%;
              top: 96%;
              transform: translate(0%, 0%);
            }

            &.bottom-right-pos:before {
              left: 58%;
              top: 96%;
              transform: translate(0%, 0%);
            }

            &.top-pos:before {
              left: 50%;
              top: -3px;
              transform: translate(0%, 0%);
            }

            &.top-left-pos:before {
              left: 32%;
              top: -3px;
              transform: translate(0%, 0%);
            }

            &.top-right-pos:before {
              left: 58%;
              top: -3px;
              transform: translate(0%, 0%);
            }

            &.bottom-pos-sta:before {
              left: 50%;
              top: 95%;
              transform: translate(0%, 0%);
            }

            &:before {
              position: absolute;
              display: block;
              content: "";
              height: 8px;
              width: 8px;
              border-radius: 4px;
              top: 50%;
            }

            .bold {
              font-weight: 800;
            }

            .valve-sign {
              margin-top: auto;
              margin-bottom: auto;
              width: 12px;
              height: 12px;
              background-color: #ffff00;
              animation: breathee-valve-sign-default 1500ms infinite alternate ease-in-out;
              border-radius: 10px;
              margin-left: 12px;

              &.running {
                background-color: #67dd34;
                animation: none;
              }

              &.stopped {
                background-color: #a0a0a0;
                animation: none;
              }
            }
          }

          .Warning {
            border-color: #ffff00;
            animation: breathee-warning 1500ms infinite alternate ease-in-out;
          }

          .Error {
            border-color: #ff0000;
            animation: breathee-error 1500ms infinite alternate ease-in-out;
          }
        }

        .clip {
          position: absolute;
          width: 16px;
          height: 16px;
          border-radius: 8px;

          &:before,
          &:after {
            position: absolute;
            display: block;
            content: "";
            height: 2px;
          }

          &:before {
            width: 50px;
          }

          &:after {
            width: 15px;
          }

          .state-info {
            font-size: 14px;
            line-height: 17px;
            color: #515151;
            text-align: right;
            min-width: 75px;
            transform: translateY(-50%);
            position: absolute;
            border-radius: 10px;
            box-sizing: border-box;
            padding: 6px 8px 6px 6px;
            border: 2px solid transparent;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);

            &>p {
              margin: 0;
              white-space: nowrap;

              &:first-child {
                font-size: 13px;
              }
            }

            &.right-pos:before {
              right: 0;
              transform: translate(50%, -50%);
            }

            &.left-pos:before {
              left: -8px;
              transform: translate(50%, -50%);
            }

            &.bottom-pos:before {
              left: 50%;
              top: 90%;
              transform: translate(0%, 0%);
            }

            &:before {
              position: absolute;
              display: block;
              content: "";
              height: 8px;
              width: 8px;
              border-radius: 4px;
              top: 50%;
            }
          }

          .Warning {
            border-color: #ffff00;
            animation: breathee-warning 1500ms infinite alternate ease-in-out;
          }

          .Error {
            border-color: #ff0000;
            animation: breathee-error 1500ms infinite alternate ease-in-out;
          }

          &.sensor1 {
            background: #c7798b;

            &:after,
            &:before {
              background: #c7798b;
            }

            .state-info {
              background-color: rgba(246, 250, 255, 0.9);

              &:before {
                background-color: #c7798b;
              }
            }
          }

          &.sensor2 {
            background: #3376c7;

            &:after,
            &:before {
              background: #3376c7;
            }

            .state-info {
              background-color: rgba(246, 250, 255, 0.9);

              &:before {
                background-color: #3376c7;
              }
            }
          }
        }

        .station-block-z3-top {
          top: 115px;
          left: 269px;
        }

        .station-block-z3-mid {
          top: 202px;
          left: 269px;
        }

        .station-block-z4-top {
          top: 115px;
          left: 625px;
        }

        .station-block-z4-mid {
          top: 202px;
          left: 625px;
        }

        .station-block-z5-top {
          top: 115px;
          left: 979px;
        }

        .station-block-z5-mid {
          top: 202px;
          left: 979px;
        }

        .station-block-rigidhinge-up {
          top: 202px;
          left: 1146px;
        }

        .sta-z3-top {
          top: 108px;
          left: 282px;

          &::before {
            bottom: 0px;
            left: -25px;
            width: 50px;
            transform: rotate(90deg);
          }

          &::after {
            bottom: -49px;
            left: -17px;
            width: 0;
          }

          .state-info {
            right: -93px;
            top: -70px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 195px;
          }
        }

        .sta-z3-mid {
          top: 222px;
          left: 150px;

          &::before {
            bottom: 34px;
            left: 89px;
            width: 60px;
            transform: rotate(75deg);
          }

          &::after {
            bottom: 62px;
            left: 81px;
            width: 30px;
          }

          .state-info {
            right: -81px;
            top: -62px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 195px;
          }
        }

        .sta-z4-top {
          top: 108px;
          left: 636px;

          &::before {
            bottom: 0px;
            left: -25px;
            width: 50px;
            transform: rotate(90deg);
          }

          &::after {
            bottom: -49px;
            left: -17px;
            width: 0;
          }

          .state-info {
            right: -93px;
            top: -70px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 195px;
          }
        }

        .sta-z4-mid {
          top: 222px;
          left: 505px;

          &::before {
            bottom: 34px;
            left: 89px;
            width: 60px;
            transform: rotate(75deg);
          }

          &::after {
            bottom: 62px;
            left: 81px;
            width: 30px;
          }

          .state-info {
            right: -81px;
            top: -62px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 195px;
          }
        }

        .sta-z5-top {
          top: 108px;
          left: 991px;

          &::before {
            bottom: 0px;
            left: -25px;
            width: 50px;
            transform: rotate(90deg);
          }

          &::after {
            bottom: -49px;
            left: -17px;
            width: 0;
          }

          .state-info {
            right: -93px;
            top: -70px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 195px;
          }
        }

        .sta-z5-mid {
          top: 222px;
          left: 860px;

          &::before {
            bottom: 34px;
            left: 89px;
            width: 60px;
            transform: rotate(75deg);
          }

          &::after {
            bottom: 62px;
            left: 81px;
            width: 30px;
          }

          .state-info {
            right: -81px;
            top: -62px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 195px;
          }
        }

        .sta-rigidhinge-up-up {
          top: 222px;
          left: 1056px;

          &::before {
            bottom: 20px;
            left: 92px;
            width: 20px;
            transform: rotate(90deg);
          }

          &::after {
            bottom: 62px;
            left: 81px;
            width: 0px;
          }

          .state-info {
            right: -230px;
            top: -86px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 195px;
          }
        }

        .sta-rigidhinge-up-down {
          top: 222px;
          left: 1056px;

          &::before {
            bottom: -10px;
            left: 92px;
            width: 20px;
            transform: rotate(270deg);
          }

          &::after {
            bottom: 62px;
            left: 81px;
            width: 0px;
          }

          .state-info {
            right: -230px;
            top: 64px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 195px;
          }
        }

        .station-block-rigidhinge-down {
          top: 202px;
          left: 0px;
        }

        .station-block-z6-top {
          top: 115px;
          left: 188px;
        }

        .station-block-z6-mid {
          top: 202px;
          left: 188px;
        }

        .station-block-z7-top {
          top: 115px;
          left: 542px;
        }

        .station-block-z7-mid {
          top: 202px;
          left: 542px;
        }

        .station-block-z8-top {
          top: 115px;
          left: 898px;
        }

        .station-block-z8-mid {
          top: 202px;
          left: 898px;
        }

        .sta-rigidhinge-down-up {
          top: 222px;
          left: -90px;

          &::before {
            bottom: 20px;
            left: 92px;
            width: 20px;
            transform: rotate(90deg);
          }

          &::after {
            bottom: 62px;
            left: 81px;
            width: 0px;
          }

          .state-info {
            right: -180px;
            top: -86px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 195px;
          }
        }

        .sta-rigidhinge-down-down {
          top: 222px;
          left: -90px;

          &::before {
            bottom: -10px;
            left: 92px;
            width: 20px;
            transform: rotate(270deg);
          }

          &::after {
            bottom: 62px;
            left: 81px;
            width: 0px;
          }

          .state-info {
            right: -180px;
            top: 64px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 195px;
          }
        }

        .sta-z6-top {
          top: 108px;
          left: 199px;

          &::before {
            bottom: 0px;
            left: -25px;
            width: 50px;
            transform: rotate(90deg);
          }

          &::after {
            bottom: -49px;
            left: -17px;
            width: 0;
          }

          .state-info {
            right: -93px;
            top: -70px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 195px;
          }
        }

        .sta-z6-mid {
          top: 222px;
          left: 73px;

          &::before {
            bottom: 34px;
            left: 108px;
            width: 60px;
            transform: rotate(105deg);
          }

          &::after {
            bottom: 62px;
            left: 145px;
            width: 30px;
          }

          .state-info {
            right: -370px;
            top: -63px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 195px;
          }
        }

        .sta-z7-top {
          top: 108px;
          left: 554px;

          &::before {
            bottom: 0px;
            left: -25px;
            width: 50px;
            transform: rotate(90deg);
          }

          &::after {
            bottom: -49px;
            left: -17px;
            width: 0;
          }

          .state-info {
            right: -93px;
            top: -70px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 195px;
          }
        }

        .sta-z7-mid {
          top: 222px;
          left: 428px;

          &::before {
            bottom: 34px;
            left: 108px;
            width: 60px;
            transform: rotate(105deg);
          }

          &::after {
            bottom: 62px;
            left: 145px;
            width: 30px;
          }

          .state-info {
            right: -370px;
            top: -63px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 195px;
          }
        }

        .sta-z8-top {
          top: 108px;
          left: 910px;

          &::before {
            bottom: 0px;
            left: -25px;
            width: 50px;
            transform: rotate(90deg);
          }

          &::after {
            bottom: -49px;
            left: -17px;
            width: 0;
          }

          .state-info {
            right: -93px;
            top: -70px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 195px;
          }
        }

        .sta-z8-mid {
          top: 222px;
          left: 783px;

          &::before {
            bottom: 34px;
            left: 108px;
            width: 60px;
            transform: rotate(105deg);
          }

          &::after {
            bottom: 62px;
            left: 145px;
            width: 30px;
          }

          .state-info {
            right: -370px;
            top: -63px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 195px;
          }
        }
      }
    }
  }
}
</style>